/** Exact Korean UI literals → English for locale!=="kr". */
export const HARDCODED_KO_EN: Record<string, string> = {
  " (끔 — 열린 건은 끝까지 유지)": " (off — open trades kept to the end)",
  " (둘 다 OFF)": " (both OFF)",
  " / 다음 ": " / next ",
  " 18칸인데 트리거는 하루 240건).": " 18 slots but ~240 triggers/day).",
  " [빗숏]": " [Bithumb short]",
  "↳급락": "↳Dump",
  "↳되돌림": "↳Pullback",
  "↳익절2": "↳TP2",
  "↳ 급락": "↳ Dump",
  "↳ 되돌림": "↳ Pullback",
  "↳ 익절2 별책": "↳ TP2 side book",
  "bh_dump만 · 주문 OFF": "bh_dump only · orders OFF",
  "book만 · 통합계와 겹치면 급락 우선": "book only · dump wins if overlaps unified book",
  " · %eq 앵커는 패널 잔고행": " · %eq anchor is the panel equity row",
  " · DB 없음 — yaml·기본배분 표시": " · no DB — showing yaml·default alloc",
  " · LSK형 캘린더 창 신규 스킵": " · skip new entries in LSK-class calendar window",
  " · k=0(캡 잔여·실조각만 예약)": " · k=0 (cap remainder·real legs only reserved)",
  " · seg≥20 · KST 18–24 · 촉매제외 · −10%/4시간 · 15분에 더 높으면 미진입 · 산은 알림에 바로": " · seg≥20 · KST 18–24 · catalyst exclude · −10%/4h · skip if higher within 15m · mountain enters on alert",
  " · ⚠ 한계기여 −": " · ⚠ marginal contrib −",
  " · 고점확인 OFF · 같은 k·조각·캡": " · peak confirm OFF · same k·legs·cap",
  " · 규칙이 아니라 레인 자체 · 누적청산(Σn_liq) 구간별 성적": " · lane itself, not a rule · score by cum liq (Σn_liq) bucket",
  " · 규칙이 아니라 레인 자체 · 화이트 트리거 · leg(cum 문턱)별": " · lane itself, not a rule · whitelist triggers · by leg (cum threshold)",
  " · 규칙이 아니라 레인 자체 · 확인 깔때기·타이밍·사다리": " · lane itself, not a rule · confirm funnel·timing·ladder",
  " · 배수 반영 합 ": " · multiplier-applied sum ",
  " · 산은 진입가 +15% 위에서 OI 진입 대비 −2% 이하면 시장가 (숏커버 스퀴즈)": " · mountain: market close if entry+15% and OI ≤ entry−2% (short-cover squeeze)",
  " · 상세는 아래 표 진입정지·CF$ 행": " · details in entry-halt·CF$ rows below",
  " · 아직 적재 없음": " · nothing loaded yet",
  " · 자리없으면 같은종목 연책조각(평단 좋은 쪽)": " · if no slot, same-symbol book add (better avg side)",
  " · 정산 없음": " · no settles",
  " · 정산 없음 (라이브 OFF)": " · no settles (live OFF)",
  " · 조각최대 ": " · max legs ",
  " · 주문=라이브스택": " · orders=live stack",
  " · 체결 없음": " · no fills",
  " · 한계기여 OK": " · marginal contrib OK",
  " · 합 ": " · sum ",
  " — v1 게이트 OFF (liq_v1_enabled, 2026-09-09). 이 채점은 참고용.": " — v1 gate OFF (liq_v1_enabled, 2026-09-09). This score is reference only.",
  " — 끔. 업숏·빗숏이 각자 k 를 쓴다": " — off. Upbit short·Bithumb short each use their own k",
  " — 배분>100%(선진입 우선, 저장 가능)": " — alloc>100% (first-in priority, savable)",
  " — 셀 ": " — cell ",
  " — 업숏·빗숏 종속 (레인 아님)": " — Upbit short·Bithumb short dependent (not a lane)",
  " — 자본 초과, 동시에 다 못 들어간다": " — over capital; cannot enter all at once",
  " — 지금 도는 설정": " — current live settings",
  " — 지금 도는 설정 · 셀 ": " — current live settings · cell ",
  " — 참고용 · 값은 위에서 고정": " — reference · values fixed above",
  " 그 시각에 청산하는 규칙으로는 그 값을 못 얻고,": " that exit rule at that time cannot get that value,",
  " 문턱 이미 진입": " threshold already taken",
  " 밖": " outside",
  " 보유는 슬롯·비용까지 넣은 격자 총합의 답이다": " Open answers the grid total with slots·cost included",
  " 시작": " start",
  " 아래 레인별 k 는 상한일 뿐 합이 아니다": " per-lane k below is a cap only, not a sum",
  " 어긋나는 것이 정상이다. 최선은 사후 최선 시점이라": " mismatch is normal. Best is ex-post best time so",
  "% (러닝고점 대비 이만큼 꺾이면 진입 · 0 = 트리거가 즉시)": "% (enter after this drop from running peak · 0 = trigger enters immediately)",
  "% (슬리브 등분 · 신고가가 직전조각 +이만큼일 때 다음 조각)": "% (sleeve split · next leg when new high is +this vs prior leg)",
  "% (진입가가 캐스케이드 고점 대비 이만큼 아래면 슬리브 ×배수 · 1× = OFF)": "% (if entry is this far below cascade peak, sleeve ×mult · 1× = OFF)",
  "% · 모양(ratio)": "% · shape (ratio)",
  "%명목 +": "% notional +",
  "%증거금": "% margin",
  "(별도 스위치 없음 — 위에서 청캐를 끄면 낙하칼도 같이 꺼진다).": "(no separate switch — turning liq cascade off above also turns drop knife off).",
  "(홀드 240분 = 자리 4시간 점유, k=3 이면 하루": "(hold 240m = seat occupied 4h; with k=3, one day",
  ") 격자 권고": ") grid recommendation",
  "+25% · +15%&OI−2% 시장가": "+25% · +15%&OI−2% market",
  "+3% 역행이 45초 이후 + continuation(45~120초)": "+3% adverse after 45s + continuation (45~120s)",
  "+5% 익절": "+5% take profit",
  "/rung · 캡": "/rung · cap",
  "0 = 상한 없음(캡만). >0 이면 같은종목 동시 슬리브 상한": "0 = no limit (cap only). >0 = max concurrent sleeves per symbol",
  "0 이면 그 필터는 **돈을 버린 것**이고,": "0 means that filter **threw money away**,",
  "0 이면 옛 레인별 k 로 돌아간다": "0 reverts to old per-lane k",
  "0건": "0 trades",
  "10% 배수": "10% mult",
  "10%→20% gap < 2h": "10%→20% gap < 2h",
  "12% 안": "within 12%",
  "120분": "120m",
  "12시간마다": "every 12h",
  "15분": "15m",
  "15초~15분": "15s~15m",
  "1st 건당": "1st per trade",
  "1st 승률": "1st win rate",
  "20% 구간 제외": "Skip ≥20% segment",
  "210분": "210m",
  "24시간": "24h",
  "3rd+ 건당": "3rd+ per trade",
  "3rd+ 승률": "3rd+ win rate",
  "3등분": "Tertiles",
  "4시간": "4h",
  "4시간 창의 청산이 19건 이상이거나 롤 $9만 이상, 또는 알림 뒤 고점 +7.5%인데 되돌림이 그 상승분의 35% 이하.": "≥19 liqs in 4h window or ≥$90k roll, or after alert peak +7.5% but pullback ≤35% of that rise.",
  "4시간마다": "every 4h",
  "50~99 건당": "50~99 per trade",
  "50~99 승률": "50~99 win rate",
  "5분": "5m",
  "60초": "60s",
  "75/50/캡150": "75/50/cap150",
  "8분": "8m",
  "8분 저점 대비 +15% 첫 돌파 · 직전 15초 +8% 이상이면 롱": "First break +15% vs 8m low · long if prior 15s ≥+8%",
  "90분": "90m",
  "<1 앞무겁게 · 1 균등 · >1 뒤무겁게": "<1 front-heavy · 1 equal · >1 back-heavy",
  "=배포": "=deployed",
  "ABORT": "ABORT",
  "BTC 60m 상승 과다": "BTC 60m rise too high",
  "Binance perp 없음": "No Binance perp",
  "DB 저장됨": "Saved to DB",
  "Face ID / Touch ID 로 등록": "Enroll with Face ID / Touch ID",
  "Globex 일 18:00–금 17:00 ET · 휴장 17–18 ET": "Globex Sun 18:00–Fri 17:00 ET · closed 17–18 ET",
  "KR 고구간 사다리 (레인공유)": "KR high-segment ladder (lane share)",
  "KR급등": "KR surge",
  "KST 18–24 밖": "Outside KST 18–24",
  "KST 18–24 밖이고 산 조건이 알림 시각에 맞으면 바로 숏. 되돌림을 기다리지 않는다. 빈 자리만.": "Outside KST 18–24, if mountain fits at alert time, short immediately. No pullback wait. Empty slots only.",
  "MED면 숏 flat→LONG trail40→붕괴숏. eq−50 헤지 OFF. eq스탑(−80)은 별칸.": "On MED: short flat→LONG trail40→collapse short. eq−50 hedge OFF. eq stop (−80) is a separate cell.",
  "MES·MNQ·MGC·ZN 일봉 롱 · paper": "MES·MNQ·MGC·ZN daily long · paper",
  "OI 밀림 · 숏 제외": "OI push · skip short",
  "OIΔ≥1.5% + 매수세 증가(30~45초). 느린 유입": "OIΔ≥1.5% + rising buy flow (30~45s). Slow inflow",
  "[쌍숏진입] 업숏에서처리": "[Dual-short entry] handled in Upbit short",
  "abort 확인": "abort confirm",
  "abort/no_pullback 뒤 재숏 금지": "No re-short after abort/no_pullback",
  "cascade-fade 격자 (파도 breadth · tick mark · 관문 통과=최적 패키지)": "cascade-fade grid (wave breadth · tick mark · gate pass=best package)",
  "cascade-fade 미발생 (감시창 만료)": "No cascade-fade (watch expired)",
  "concurrent 부족": "Concurrent too low",
  "drop성립": "drop ok",
  "eq스탑": "eq stop",
  "fade 관문 미달:": "fade gate miss:",
  "fade 마스터 OFF (대기 종료)": "Fade master OFF (watch end)",
  "fade 주문 OFF (기록만)": "Fade orders OFF (log only)",
  "fade고정": "fade fixed",
  "halted (킬스위치)": "halted (kill switch)",
  "k 는 사이징에 안 쓴다": "k is not used in sizing",
  "k=0 · 동시 상한 없음(캡·실조각만).": "k=0 · no concurrent limit (cap·real legs only).",
  "k=0 캡만": "k=0 cap only",
  "k=2 · 같은 종목 210분": "k=2 · same symbol 210m",
  "kind=\"stop\" 이거나 leg 필드 도입 전 구행": "kind=\"stop\" or legacy rows before leg field",
  "lag중앙": "lag median",
  "leg1 승률": "leg1 win rate",
  "leg1≥20 건당": "leg1≥20 per trade",
  "leg2 승률": "leg2 win rate",
  "leg2≥35 건당": "leg2≥35 per trade",
  "leg3 승률": "leg3 win rate",
  "leg3≥50 건당": "leg3≥50 per trade",
  "leg4 승률": "leg4 win rate",
  "leg4≥65 건당": "leg4≥65 per trade",
  "linear 레인마진 한도": "Linear lane-margin cap",
  "mark 1초 갱신": "mark 1s refresh",
  "mark 끊김": "mark gap",
  "open/k. 청캐 v2·v3는 각 행.": "open/k. Liq cascade v2·v3 each row.",
  "peak도달": "peak hit",
  "rung1 건당": "rung1 per trade",
  "rung1 승률": "rung1 win rate",
  "rung2+ 건당": "rung2+ per trade",
  "rung2+ 승률": "rung2+ win rate",
  "segment +10%p 당 +1×": "+1× per +10%p segment",
  "segment 하한 미달": "Below segment floor",
  "v1 (누적청산 &lt;100)": "v1 (cum liq &lt;100)",
  "v1 되돌림은": "v1 pullback is",
  "v1 진입 정지 (누적청산 <100)": "v1 entry halted (cum liq <100)",
  "v1·v2·v3 · 스택과 동일 축 · 잔고밀림%=시작대비 · 창": "v1·v2·v3 · same axis as stack · eq drawdown%=vs start · window",
  "v2 감시": "v2 Watch",
  "v2 감시(고점확인)": "v2 Watch (peak confirm)",
  "v2 사다리 (누적청산 ≥100)": "v2 ladder (cum liq ≥100)",
  "v2 조각 상한 미상": "v2 leg cap unknown",
  "v2(사다리) 엔진 — v1 진입 정지": "v2 ladder engine — v1 entry halted",
  "v3 · v2 보유": "v3 · v2 holding",
  "v3 문턱 미달": "v3 below threshold",
  "v3 미진입": "v3 no entry",
  "v3 자리 없음": "v3 no slot",
  "v3 중복": "v3 duplicate",
  "v3는 v2에 양보": "v3 yields to v2",
  "vs배포": "vs deployed",
  "· 업숏·빗숏 공유": "· Upbit short·Bithumb short shared",
  "· 정산 없음": "· no settles",
  "· 지금 도는 설정": "· current live settings",
  "· 체질 채점": "· constitution score",
  "· 화면 설정).": "· screen settings).",
  "× · 고점 대비": "× · vs peak",
  "×/10% · 캡": "×/10% · cap",
  "Δ합": "Δ sum",
  "— 동시 포지션 개수 레일.": "— concurrent position-count rail.",
  "※ 자동적용 OFF — 라이브는 이 행을 읽지 않는다. 통과해도 권고다.": "※ auto-apply OFF — live does not read this row. Pass is advisory only.",
  "※ 총합은": "※ Total is",
  "→되돌림": "→pullback",
  "−10% · 4시간": "−10% · 4h",
  "≤15초": "≤15s",
  "≤−2%/60초": "≤−2%/60s",
  "≥100 건당": "≥100 per trade",
  "≥100 승률": "≥100 win rate",
  "≥19건·$9만 또는 고점+7.5%·≤35%": "≥19·$90k or peak+7.5%·≤35%",
  "≥3시간": "≥3h",
  "○ 라이브 OFF": "○ Live OFF",
  "○ 쌍숏 OFF": "○ Dual short OFF",
  "○ 촉매 진입정지 OFF — 재해헤지 · LSK 등 신규 허용": "○ Catalyst entry halt OFF — disaster hedge · LSK etc new allowed",
  "○ 촉매 진입정지 — 지금 창 없음": "○ Catalyst entry halt — no window now",
  "● 라이브 ON": "● Live ON",
  "● 쌍숏 ON": "● Dual short ON",
  "● 촉매 시드 상태 없음 — 조사 잡 확인": "● No catalyst seed status — check research job",
  "● 촉매 시드 조사 실패 — 새 촉매를 자동으로 못 찾음": "● Catalyst seed research failed — cannot find new catalysts automatically",
  "● 촉매 시드 조사 지연 — 마지막 성공 후 30h 초과": "● Catalyst seed research stale — >30h since last success",
  "⚠ 되돌림 구조 붕괴 — peak는 나오는데 되돌림 진입이 안 된다. Top1 전제가 깨진 신호": "⚠ Pullback structure break — peaks appear but pullback entries fail. Top1 premise broken",
  "⚠ 사다리 구조 역전 — 깊은 구간이 초입보다 나쁘다. v2 의 전제가 깨진 신호": "⚠ Ladder structure reversal — deep buckets worse than early. v2 premise broken",
  "⚠ 스탑이 늘었다 — taken 중 25%를 넘는다": "⚠ Stops rose — over 25% of taken",
  "⚠ 재진입 역전 — leg2+ 가 leg1보다 나쁘다": "⚠ Re-entry reversal — leg2+ worse than leg1",
  "⚠ 진입이 늦다 — 중앙이 60분을 넘는다": "⚠ Entry late — median over 60m",
  "⚠ 타이밍 밀림 — 진입 중앙이 감시창 뒤로 밀린다. 예전에 레인을 죽인 신호": "⚠ Timing slip — entry median past watch window. Historically killed the lane",
  "⚠ 타이밍 밀림 — 확인이 늦다. 9월 드리프트 축": "⚠ Timing slip — confirm late. Sep drift axis",
  "⚠ 확인 구조 붕괴 — 확인률이 경보선 미만. 편승 전제가 깨진 신호": "⚠ Confirm structure break — confirm rate below alarm line. Pump ride premise broken",
  "✅ 등록 완료": "✅ Enrolled",
  "✓ 스탑 비중 정상 — taken 중 25% 안": "✓ Stop share OK — within 25% of taken",
  "✓ 진입 타이밍 정상 — 중앙이 60분 안": "✓ Entry timing OK — median within 60m",
  "가격 손절. 없으면 없음.": "Price stop. None if empty.",
  "가격 스탑 없음 · eq스탑(산시작 대비 잔고 −80%)은 규칙표": "No price stop · eq stop (equity −80% vs mountain start) is on the rules table",
  "가격% × 명목% (75/50/캡150 · k=2). 되돌림 동색 · 급락 은색 · 전승별책 금.": "Price% × notional% (75/50/cap150 · k=2). Pullback bronze · dump silver · WR100 gold.",
  "가격% × 실제 명목% (75/50/캡100 · k=2). 되돌림 동색 · 산 은색 · 전승별책 금.": "Price% × actual notional% (75/50/cap100 · k=2). Pullback bronze · mountain silver · WR100 gold.",
  "가격%가 −10% 이하로 끝난 뒤 4시간은 그 종목을 다시 안 넣는다.": "After price% ends ≤−10%, skip that symbol for 4h.",
  "가격이 그 산의 고점 12% 안.": "Price within 12% of that mountain's peak.",
  "가속 없음": "No acceleration",
  "가운데서 이미 조건 충족 (cold)": "Already met mid-window (cold)",
  "가장 오래된": "Oldest",
  "간격": "Interval",
  "감시": "Watch",
  "감시 중 요구하는 고점.": "Peak required while watching.",
  "감시종료": "Watch end",
  "감시중": "Watching",
  "감지 지연": "Detect lag",
  "값을 바꿔야 하나": "Should we change the value?",
  "값이다 — 라이브 손익이 아니다. 셀 사이의 비교로만 쓰고, 실적은 원장(live_ledger)을 볼 것.": "value — not live PnL. Compare cells only; see ledger (live_ledger) for results.",
  "값이다 — 라이브 손익이 아니다. 실적은 원장(live_ledger) · 위 일일채점을 볼 것.": "value — not live PnL. See ledger (live_ledger) · daily score above.",
  "강제청산": "Forced liquidation",
  "같은 산에서 다시 들어가는 누적청산 간격.": "Cum-liq interval before re-entering the same mountain.",
  "같은 심볼 보유중": "Same symbol already open",
  "같은 심볼 업숏 보유중": "Same-symbol Upbit short open",
  "같은 종목은 이 시간이 지나야 다시 진입.": "Same symbol may re-enter only after this time.",
  "같은 코인 업비트 알림이": "Same-coin Upbit alert",
  "같은종목 연책": "Same-symbol book",
  "같은종목 연책(평단 나쁜 쪽)": "Same-symbol book (worse avg side)",
  "같은종목 연책(평단 좋은 쪽)": "Same-symbol book (better avg side)",
  "개 · 조각 폭": "count · leg width",
  "건 /": " /",
  "건 / 다음 ": " / next ",
  "건 →": " →",
  "건강도 — 연장 깔때기·한계기여": "Health — extend funnel·marginal contrib",
  "건강도 적재가 없다.": "No health data loaded.",
  "건당": "Per trade",
  "건당 net% 단순합 · 실현%eq·잔고밀림은 엔진별 캡/k 사이징 합산": "Simple sum of per-trade net% · realized%eq·eq drawdown use per-engine cap/k sizing sum",
  "게이트 n": "Gate n",
  "격자": "Grid",
  "격자 건수": "Grid count",
  "격자 실행": "Grid run",
  "격자 전체 셀 중 승률 순위": "Win-rate rank among all grid cells",
  "격자 총합 top5 (롤링": "Grid total top5 (rolling",
  "격자 총합은 재생 프레임(원장≠). path ON이면 체질 CF 채점 — 전건 스프레이와 섞지 않는다. 주문은 별도 스위치.": "Grid total is replay frame (≠ledger). path ON → constitution CF score — don't mix with all-trade spray. Orders are a separate switch.",
  "겹": "Gy",
  "겹롱": "Gyeop long",
  "겹롱 진입가 −5% 이하면 시장가 (소프트)": "Gyeop long: market if ≤ entry−5% (soft)",
  "겹침k": "overlap k",
  "경로청산": "Path exit",
  "경보": "Alarm",
  "경보선 n≥10 · 승률 45% / 건당 +0.5% / MDD −50 · 확인률 25% · lag 90m (사전등록 2026-09-19). 격자 총합과 섞어 읽지 말 것.": "Alarm n≥10 · win 45% / per trade +0.5% / MDD −50 · confirm 25% · lag 90m (prereg 2026-09-19). Don't mix with grid total.",
  "경보선 n≥10 · 승률 75% / 건당 +4.0% / MDD −40 (사전등록 2026-09-06).": "Alarm n≥10 · win 75% / per trade +4.0% / MDD −40 (prereg 2026-09-06).",
  "경보선 n≥8 · 승률 50% / 건당 +1.0% / MDD −30 · v2와 같은 45일 창 · 원장은 liqv3_settle만 (라이브 OFF면 빈칸).": "Alarm n≥8 · win 50% / per trade +1.0% / MDD −30 · same 45d window as v2 · ledger is liqv3_settle only (blank if live OFF).",
  "계": "Total",
  "고점": "Peak",
  "고점 뒤 15분 초과": ">15m after peak",
  "고점 뒤 −되돌림까지 이 구간. 15초 미만은 age_floor, 15분 초과는 peak_age.": "Window from peak to −pullback. <15s = age_floor, >15m = peak_age.",
  "고점 미달 (감시창 만료)": "Peak too low (watch expired)",
  "고점6 · 꺾임2 · 감시15 · 홀드15": "Peak6 · drop2 · watch15 · hold15",
  "고점뒤": "After peak",
  "고점을 통과한 슬리브의 크기 배수.": "Size multiplier for sleeves that passed the peak.",
  "고점탈환": "Peak reclaim",
  "고점통과": "Peak pass",
  "고점확인": "Peak confirm",
  "고점확인 OFF": "Peak confirm OFF",
  "고점확인 ON": "Peak confirm ON",
  "고점확인 후 첫 조각": "First leg after peak confirm",
  "고점확인ON(arm+15%·X5%·Y30m) 후 · ": "After peak confirm ON (arm+15%·X5%·Y30m) · ",
  "공유": "Shared",
  "공유 슬롯 · 청캐 우선 (DB 정본)": "Shared slots · liq cascade priority (DB SoT)",
  "관문 미달:": "Gate miss:",
  "관문: 배포 우위 · n≥6 · 3등분 전부 양수 · 대조 excess&gt;0 · 감시 고원 · 스파이크 금지 · 이웃 과반 초과 · min_gain.": "Gate: beat deployed · n≥6 · all tertiles >0 · control excess&gt;0 · watch plateau · no spikes · beat neighbor majority · min_gain.",
  "관문: 배포 우위 · n≥8 · 3등분 전부 양수 · 격자 모서리 금지 · 이웃 과반 초과. &quot;총합1위&quot;는 관문과 무관한 참고칸이라 채택 범위 밖도 올라온다.": "Gate: beat deployed · n≥8 · all tertiles >0 · no grid corners · beat neighbor majority. &quot;Total #1&quot; is unrelated reference — can rank outside adopt range.",
  "관문을 넘은 셀 없음": "No cell passed the gate",
  "관문을 넘은 셀 없음 (정상)": "No cell passed the gate (normal)",
  "관찰 중 (OI 스퀴즈 후보 · 숏 보류)": "Watching (OI squeeze candidate · short held)",
  "관찰 타이밍 놓침": "Missed watch timing",
  "구간": "Segment",
  "구간 10%가 1단. 그 단의 명목, 자본 대비 %.": "Each 10% segment is 1 rung. That rung's notional, % of capital.",
  "구간 상승": "Segment rise",
  "구간 상승이 이 이상인 알림만.": "Alerts with segment rise at least this.",
  "구간 시작 잔고 대비 잔고밀림% (2026-10-18)": "Eq drawdown% vs window-start equity (2026-10-18)",
  "구간 시작 잔고 대비 잔고밀림% (화면과 같은 축, 2026-10-18).": "Eq drawdown% vs window-start equity (same axis as screen, 2026-10-18).",
  "구간 하락": "Segment fall",
  "구간상승": "Segment rise",
  "구간이 10%p 오를 때마다 명목에 더하는 %p. 20%는 2단, 30%는 3단.": "%p added to notional each +10%p segment. 20%=rung2, 30%=rung3.",
  "구간하락": "Segment fall",
  "구조홀드(연장) 일일 채점": "Structure hold (extend) daily score",
  "권고만": "Advisory only",
  "규칙": "Rule",
  "규칙 성적 — 셀 (얕은산 S10)": "Rule score — cell (shallow mountain S10)",
  "규칙이 발동했다": "Rule fired",
  "규칙이 보고 통과시켰다": "Rule reviewed and passed",
  "균등": "Equal",
  "그 레인이 쓸 수 있는 증거금 상한. 자본 대비 %. 넘치면 남은 만큼만 들어간다.": "Margin cap this lane may use. % of capital. If over, enter with remainder only.",
  "그 시간 안 역행이 이 이상이면 진입 취소.": "Cancel entry if adverse move ≥ this within that time.",
  "그 칸 최소 건손익(%p)": "Min per-trade PnL (%p) for that cell",
  "그 칸 최소 건손익(%p) — 꼬리 크기": "Min per-trade PnL (%p) for that cell — tail size",
  "그냥 뒀으면?": "If left alone?",
  "급가격": "Fast price",
  "급등 편승 롱": "Surge pump-ride long",
  "급락": "Dump",
  "급락 스캘프": "Dump scalp",
  "급락 스캘프 진입 실패": "Dump scalp entry fail",
  "급락 스캘프 진입 실패 (-3% 미터치)": "Dump scalp fail (−3% not touched)",
  "급락 스캘프 진입 실패 (너무 빠름 lag<60s)": "Dump scalp fail (too fast lag<60s)",
  "급락 스캘프 진입 실패 (캐스케이드 · 직전6h 알림≥20)": "Dump scalp fail (cascade · ≥20 alerts/6h)",
  "급락 스캘프 진입 실패 (확인창 되돌림)": "Dump scalp fail (confirm pullback)",
  "기기": "Device",
  "기기 이름": "Device name",
  "기존 청캐(": "Existing liq cascade (",
  "기타": "Other",
  "깊은꺾임 배수": "Deep-drop mult",
  "깨짐": "Broken",
  "꺾이면 첫 조각": "drop → first leg",
  "꺾임": "Drop",
  "꺾임 2.5% · 감시 120분 · peak 2% · 홀드 90분 · 스탑 6%": "Drop 2.5% · watch 120m · peak 2% · hold 90m · stop 6%",
  "낙폭 문턱": "Drawdown threshold",
  "낙하칼": "Drop knife",
  "낙하칼 (수직낙하 즉시진입)": "Drop knife (vertical drop → immediate entry)",
  "날짜=발동 · 잔고밀림%=시작대비·실명목(원장과 동일)": "Date=trigger · eq drawdown%=vs start·real notional (same as ledger)",
  "노브(적용 overlay 포함)다.": "knobs (incl. apply overlay).",
  "놓친고점": "Missed peak",
  "누적": "Cum",
  "누적<50 건당": "Cum<50 per trade",
  "누적<50 승률": "Cum<50 win rate",
  "누적청산": "Cum liq",
  "누적청산 ": "Cum liq ",
  "누적청산 <100건 (v1 OFF)": "Cum liq <100 (v1 OFF)",
  "누적청산 ≥100 → 조각 사다리 숏": "Cum liq ≥100 → leg ladder short",
  "누적청산이 이 건수 이상일 때만 진입.": "Enter only when cum liq ≥ this count.",
  "눌림지속": "Pull continues",
  "느린펌프 (lag·mom15)": "Slow pump (lag·mom15)",
  "늦은 픽업": "Late pickup",
  "다른 레인이 보유중": "Another lane holds it",
  "다음 ": "next ",
  "다음 구간 상승": "Next segment rise",
  "다음 구간 상승 · 15분 대기 취소": "Next segment rise · cancel 15m wait",
  "단기 급등": "Short-term surge",
  "단기 급락": "Short-term drop",
  "단기급등": "Short-term surge",
  "단기급락": "Short-term drop",
  "단독 conc": "Solo conc",
  "닫기": "Close",
  "당일첫 · watch 과대 (scout)": "First of day · watch too large (scout)",
  "대금": "Notional $",
  "대기": "Pending",
  "대기표 만료": "Pending queue expired",
  "대기표 만료(60s)": "Pending queue expired (60s)",
  "대형상장": "Major listing",
  "더 높으면 미진입": "Skip if higher",
  "더 뒀으면?": "If held longer?",
  "돌파 추격": "Breakout chase",
  "동시 gap": "Concurrent gap",
  "동시에 들고 있는 포지션 개수 상한.": "Max concurrent open positions.",
  "동일심볼 재알림 (dedup)": "Same-symbol re-alert (dedup)",
  "되돌림": "Pullback",
  "되돌림 + 급락 스캘프(bh_dump·홀드30·lag≥60s·확인60s·캐스케이드<20) · 둘 다 주문": "Pullback + dump scalp (bh_dump·hold30·lag≥60s·confirm60s·cascade<20) · both order",
  "되돌림 + 급락(bh_dump·홀드30) + 익절2(r10≤0∧lag≤30·TP2/S6/H90·명목300%) · 전부 주문": "Pullback + dump (bh_dump·hold30) + TP2 (r10≤0∧lag≤30·TP2/S6/H90·notional300%) · all order",
  "되돌림 격자 총합 (관문 통과=최적 패키지)": "Pullback grid total (gate pass=best package)",
  "되돌림 격자 총합 top5 (창": "Pullback grid total top5 (window",
  "되돌림 구조 유지 — peak 후 drop 진입이 성립한다": "Pullback structure OK — drop entries after peak work",
  "되돌림 미발생 (감시창 만료)": "No pullback (watch expired)",
  "되돌림 붕괴": "Pullback collapse",
  "되돌림 유지": "Pullback OK",
  "되돌림 진입": "Pullback entry",
  "되돌림 틱의 직전 10분. 넘으면 뺀다.": "10m before the pullback tick. Drop if over.",
  "되돌림 폭 미달 (감시창 만료)": "Pullback size short (watch expired)",
  "되돌림/급락": "Pullback/Dump",
  "되돌림/급락/익절2": "Pullback/Dump/TP2",
  "되돌림/산": "Pullback/Mountain",
  "되돌림10분": "Pullback 10m",
  "되돌림: 고점 뒤 꺾임 숏": "Pullback: short after peak drop",
  "되돌림: 고점 뒤 꺾임 숏 (KST 18–24)": "Pullback: short after peak drop (KST 18–24)",
  "되돌림: 고점 뒤 꺾임 숏 (KST 18–24) · 산: 그 밖, 산 모양이면 알림에 바로 숏": "Pullback: short after peak drop (KST 18–24) · Mountain: otherwise, short on alert if mountain-shaped",
  "되돌림: 고점 뒤 꺾임 숏 · 급락: 알림 직후 −3%/120s 스캘프": "Pullback: short after peak drop · Dump: −3%/120s scalp right after alert",
  "되돌림: 고점 뒤 꺾임 숏 · 급락: 알림 직후 −3%/120s 스캘프 · 익절2: r10≤0∧lag≤30 · TP2%/S6/H90 · 명목300%": "Pullback: short after peak drop · Dump: −3%/120s scalp right after alert · TP2: r10≤0∧lag≤30 · TP2%/S6/H90 · notional300%",
  "되돌림고정": "Pullback fixed",
  "되돌림을 기다리는 시간.": "Time waiting for pullback.",
  "되밀림": "Giveback",
  "뒤무겁게": "Back-heavy",
  "등록": "Enroll",
  "등록 중…": "Enrolling…",
  "등록 토큰": "Enrollment token",
  "등록됨": "Enrolled",
  "또는 no_pullback": "or no_pullback",
  "라이브스택": "Live stack",
  "라이브스택 — k=∞": "Live stack — k=∞",
  "라이브스택 상세": "Live stack detail",
  "라이브스택 연장경로 — rescue*/depth_gate": "Live stack extend path — rescue*/depth_gate",
  "라이브스택(고점확인OFF) — 지금 라이브 · 날짜=발동 KST": "Live stack (peak confirm OFF) — current live · date=trigger KST",
  "라이브스택(고점확인ON) — 반사실 · 촉매 진입정지": "Live stack (peak confirm ON) — counterfactual · catalyst entry halt",
  "라이브스택=주문": "Live stack=orders",
  "락중": "Locked",
  "런업高": "Run-up high",
  "레인": "Lane",
  "레인 건강도": "Lane health",
  "레인 건강도 — 규칙이 아니라 청캐 레인 자체": "Lane health — liq cascade lane itself, not a rule",
  "레인 건강도 — 전제·꼬리·집중 (성적과 다른 질문)": "Lane health — premises·tail·concentration (different question from score)",
  "레인 상한 합이 자본을 넘는다 — 먼저 들어간 쪽이 먹고 나머지는 축소·스킵": "Lane caps sum over capital — first in eats; rest shrink·skip",
  "레인 설정": "Lane settings",
  "레인OFF": "Lane OFF",
  "로 고정됐다 (2026-09-06). 아래 격자·적용은 참고용 — 매일 갈아끼우지 않는다. 건강 감시는 위 일일 채점표.": " locked (2026-09-06). Grid·apply below are reference — don't swap daily. Health watch is the daily score table above.",
  "로그 꼬리": "Log tail",
  "롱 보류": "Long held",
  "롱 전환 실험: 관찰": "Long-flip experiment: watch",
  "롱 주문 API 실패": "Long order API fail",
  "리스크": "Risk",
  "마이그레이션": "Migration",
  "마지막 수동 실행 실패": "Last manual run failed",
  "마지막 실행": "Last run",
  "마진캡": "Margin cap",
  "마크 틱 없음 (감시창 만료)": "No mark ticks (watch expired)",
  "마크 틱 조회 실패 (감시창 만료)": "Mark tick fetch fail (watch expired)",
  "만기": "Expiry",
  "만료진입 거절 (감시끝 상승)": "Expiry entry rejected (rise at expiry)",
  "매수세": "Buy pressure",
  "명목": "Notional",
  "명목 = 자본 × (rung1% + (rung−1)×step%). 캡이 넘치면 스킵이 아니라 남은 만큼 축소 진입.": "Notional = capital × (rung1% + (rung−1)×step%). If over cap, shrink entry (don't skip).",
  "명목·risk": "Notional·risk",
  "무변경": "No change",
  "무장": "Arm",
  "무장 뒤 고점에서 이만큼 되밀리면 청산.": "After arm, close if giveback from peak reaches this.",
  "무장돼도 즉시 안 쏘고": "Even when armed, don't fire immediately",
  "문턱 미달": "below threshold",
  "문턱 이미 진입": "threshold already taken",
  "뭔가 일어났다": "Something happened",
  "미fade": "No fade",
  "미결제약정이 그 산의 고점보다 5%에서 15% 아래.": "OI is 5% to 15% below that mountain's peak.",
  "미되돌림": "No pullback",
  "미무장 감시 고정 · 자동이 같은 쪽이면 SKIP": "Unarmed watch fixed · SKIP if auto picks same side",
  "미상": "Unknown",
  "미진입": "No entry",
  "바로 다음 구간 알림이 더 높고 15분 안이면 그 건은 안 들어간다. 산 진입에는 안 쓴다.": "If the next segment alert is higher within 15m, skip this one. Not used for mountain entries.",
  "반영": "Applied",
  "배분 %": "Alloc %",
  "배분 합": "Alloc sum",
  "배포": "Deployed",
  "배포 셀 총합 대비 초과": "Excess vs deployed cell total",
  "배포 패키지 총합 대비 초과": "Excess vs deployed package total",
  "백그라운드 실행 시작": "Background run started",
  "보유": "Open",
  "보유 (롱 · abort→long)": "Open (long · abort→long)",
  "본다리": "Main leg",
  "분봉 거래대금 미상/부족": "1m quote volume missing/low",
  "분전": "m ago",
  "불러오기 실패:": "Load failed:",
  "불러오는 중…": "Loading…",
  "비고": "Notes",
  "빗": "Bi",
  "빗숏": "Bithumb short",
  "빗숏 되돌림": "Bithumb pullback",
  "빗숏 진입가": "Bithumb entry",
  "빗숏 라이브스택": "Bithumb short live stack",
  "빗숏 본계~150%(seg≥30·캡)→300%": "Bithumb short main~150%(seg≥30·cap)→300%",
  "빗썸": "Bithumb",
  "빠른고점": "Fast peak",
  "사다리": "Ladder",
  "사다리 구조 유지 — 누적청산 깊을수록(≥100) 초입(<50)보다 낫다": "Ladder structure OK — deeper cum liq (≥100) beats early (<50)",
  "사다리 역전": "Ladder reversal",
  "사다리 유지": "Ladder OK",
  "사이": "Between",
  "사이즈": "Size",
  "사이징": "Sizing",
  "사이징 v2": "Sizing v2",
  "사이징 반영 실현": "Sizing-applied realized",
  "사이징 반영 실현 (칸 net 합계와 다름)": "Sizing-applied realized (≠ cell net sum)",
  "사이징=부모슬롯 따름": "Sizing=follow parent slot",
  "산 숏은 진입가 +25% STOP_MARKET. 그 전에 진입가 +15% 위에서 OI 가 진입 대비 −2% 이하면 시장가 (숏커버 스퀴즈, 2026-10-28). 아니면 210분 홀드.": "Mountain short: +25% STOP_MARKET. Before that, market if entry+15% and OI ≤ entry−2% (short-cover squeeze, 2026-10-28). Else 210m hold.",
  "산 하나당 최대 진입 횟수.": "Max entries per mountain.",
  "산OI": "Mountain OI",
  "산가격": "Mountain price",
  "산나이": "Mountain age",
  "산스탑": "Mountain stop",
  "산시작 대비 잔고밀림 ≤−80%면 전량 시장가 청산. 잔량 0까지 매 사이클 연타. halted.": "If eq drawdown ≤−80% vs mountain start → flatten market. Retry every cycle until 0. halted.",
  "산아래": "Below mountain",
  "산이 시작된 시각의 미결제약정 대비 +30% 이상.": "OI ≥ +30% vs when the mountain started.",
  "산진입": "Mountain entry",
  "산횟수": "Mountain count",
  "상세": "Detail",
  "상승": "Rise",
  "상위 (수천 셀 중 최고라 뽑기 편향이 있다 — 권고가 아니다)": "Top (best of thousands — selection bias; not a recommendation)",
  "상위1": "Top1",
  "상위1비중": "Top1 share",
  "상장": "Listing",
  "설정": "Settings",
  "설정 ·": "Settings ·",
  "성적": "Score",
  "성적 없음": "No score",
  "셀": "Cell",
  "셀 채점 — 배포 confirm/hold/k": "Cell score — deployed confirm/hold/k",
  "소프트": "Soft",
  "손실금지": "No-loss",
  "손익>0 건수 / n": "PnL>0 count / n",
  "손익>0 건수 / n (슬롯 통과분)": "PnL>0 count / n (slot-passed)",
  "수동": "Manual",
  "수동 실행": "Manual run",
  "수동진입": "Manual entry",
  "수동청산": "Manual close",
  "수집만 (미거래 거래소)": "Collect only (non-traded exchange)",
  "스킵": "Skip",
  "스탑": "Stop",
  "스탑 OFF": "Stop OFF",
  "스탑 늘음": "Stops up",
  "스탑 없음": "No stop",
  "스탑 없이 30분 들었으면?": "If held 30m with no stop?",
  "스탑 이후 다시 안 들어가는 시간.": "Cooldown after stop before re-entry.",
  "스탑 정상": "Stop OK",
  "스탑%": "Stop%",
  "스탑/미상": "Stop/Unknown",
  "스탑후": "After stop",
  "스팟": "Spot",
  "슬롯": "Slot",
  "슬롯 명목% (배분÷k)": "Slot notional% (alloc÷k)",
  "슬롯 초과": "Slot full",
  "슬롯가득": "Slots full",
  "슬리브 runup60 부족": "Sleeve runup60 too low",
  "슬리브 구간상승 상한": "Sleeve segment-rise ceiling",
  "슬리브 구간상승 하한": "Sleeve segment-rise floor",
  "슬리브 슬롯 초과": "Sleeve slots full",
  "슬리브 주문 OFF (기록만)": "Sleeve orders OFF (log only)",
  "슬리브 크기 비율. 1보다 작으면 앞 슬리브가 더 크고, 합은 캡이다.": "Sleeve size ratio. <1 → earlier sleeves larger; sum is the cap.",
  "슬리브 하나 안의 최대 조각 수.": "Max legs inside one sleeve.",
  "승/정산": "Wins/settled",
  "승률": "Win rate",
  "시간": "Time",
  "식음": "Cooldown",
  "신고가": "New high",
  "신고가정체": "New-high stall",
  "신저가": "New low",
  "실제 원장 — live_ledger · exit_reason rescue:*": "Real ledger — live_ledger · exit_reason rescue:*",
  "실제 원장 — live_ledger · v3 · 날짜=발동 KST (스택과 동일)": "Real ledger — live_ledger · v3 · date=trigger KST (same as stack)",
  "실제 원장 — live_ledger · 편승": "Real ledger — live_ledger · pump ride",
  "실패": "Fail",
  "실행 소요": "Run duration",
  "실행 조건": "Run conditions",
  "실행 중": "Running",
  "실현%eq": "Realized%eq",
  "심볼 미해석": "Symbol unresolved",
  "심볼 필터/마크 미상": "Symbol filter/mark unknown",
  "심볼·KST일 빗숏 상한": "Symbol·KST-day BH short cap",
  "심볼클러스터마다 $100 리셋": "Reset $100 per symbol cluster",
  "쌍숏": "Dual short",
  "쌍숏-EXIT": "Dual short EXIT",
  "아직 스탑이 안 났다": "No stop yet",
  "아직 적재 없음 — `analyser_upbit_rescue_daily.py --persist` 대기": "Nothing loaded yet — waiting `analyser_upbit_rescue_daily.py --persist`",
  "안 끊었으면 얼마였나": "What if we had not cut?",
  "안 끊었으면?": "If not cut?",
  "안 늘렸으면?": "If not extended?",
  "안 돌아온다": "Does not return",
  "안 쓴 자본": "Unused capital",
  "알림 뒤 고점": "Peak after alert",
  "알림 심볼 차트": "Alert symbol chart",
  "알림 이후 틱 없음 (감시창 만료)": "No ticks after alert (watch expired)",
  "알림 후 10분 안이고 직전 10분 ≥+3% 이며 고점이 +4.5~+6% 이면 뺀다 (fast_stop). 자리는 유지.": "Within 10m of alert, if prior 10m ≥+3% and peak +4.5~+6%, drop (fast_stop). Slot kept.",
  "알림10분·r10+3·고점+4.5~+6": "Alert10m·r10+3·peak+4.5~+6",
  "알림에 바로": "On alert",
  "앞무겁게": "Front-heavy",
  "약 10~15분": "~10~15m",
  "약 10분": "~10m",
  "약 35분": "~35m",
  "약 3분": "~3m",
  "얕은 사다리": "Shallow ladder",
  "얕은peak": "Shallow peak",
  "얕은r10": "Shallow r10",
  "얕은retr": "Shallow retr",
  "얕은seg": "Shallow seg",
  "얕은seg·얕은peak·얕은retr·얕은r10 이 모두 맞으면 뺀다.": "Drop if shallow seg·peak·retr·r10 all match.",
  "얕은고점": "Shallow peak",
  "얕은고점 제외": "Exclude shallow peak",
  "얕은고점의 고점.": "Shallow-peak's peak.",
  "얕은고점의 구간 상승.": "Shallow-peak segment rise.",
  "얕은고점의 되돌림 비율.": "Shallow-peak pullback ratio.",
  "얕은고점의 직전 10분.": "Shallow-peak prior 10m.",
  "업": "Up",
  "업비트": "Upbit",
  "업비트 60m runup 부족": "Upbit 60m runup too low",
  "업비트 KRW/BTC/USDT 교차상장": "Upbit KRW/BTC/USDT cross-list",
  "업비트 교차상장 N일": "Upbit cross-list N days",
  "업비트 선행(옛·끔)": "Upbit prior (legacy·off)",
  "업숏": "Upbit short",
  "업숏 k=2 인데 왜 빗숏까지 합쳐 2건에서 막히지": "Upbit short k=2 — why blocked at 2 with Bithumb short too?",
  "업숏 동시펌프에서 처리": "Handled on Upbit short dual-pump",
  "업숏 되돌림 Top1 — 일일 채점": "Upbit short pullback Top1 — daily score",
  "업숏 레인 증거금 한도%": "Upbit short lane margin limit%",
  "업숏 명목150%→300%": "Upbit short notional 150%→300%",
  "업숏 시간창 밖": "Outside Upbit short hours",
  "업숏 알림 이후 빼는 시간.": "Time to exclude after Upbit short alert.",
  "업숏 책": "Upbit short book",
  "업숏·빗숏 (공유)": "Upbit short·Bithumb short (shared)",
  "업숏제외": "Exclude Upbit short",
  "없음": "None",
  "엔진 ON": "Engine ON",
  "여유": "Free",
  "역행": "Adverse",
  "역행 1.5% + OIΔ↑ + 매수세 지속(5~90초). 스퀴즈형": "Adverse 1.5% + OIΔ↑ + sustained buy flow (5~90s). Squeeze-type",
  "역행 stop": "Adverse stop",
  "역행 문턱": "Adverse threshold",
  "연장": "Extend",
  "연장 만기": "Extend expiry",
  "연장 일일채점 로딩…": "Loading extend daily score…",
  "연장 일일채점:": "Extend daily score:",
  "연장 전 기본 보유 시간.": "Base hold time before extend.",
  "연장 중 이만큼 회복하면 청산.": "Close if recovers this much during extend.",
  "열었으면 얼마였나": "What if we had opened?",
  "오늘 업비트 알림이 온 심볼들의 24시간 1분봉 (30초 갱신)": "24h 1m bars for today's Upbit alert symbols (30s refresh)",
  "외부청산": "External close",
  "움직였나": "Did it move?",
  "원장": "Ledger",
  "원장 CF 순효과 = 회피 − 죽인엣지 (흑자였을 체결 포함)": "Ledger CF net = avoided − killed edge (includes fills that would have been green)",
  "유지": "OK",
  "익절2": "TP2",
  "r10≤0 ∧ lag≤30 · 익절2%/스탑6%/홀드90 · 스킵 구제(나이·촉매 제외) · 명목300% · 주문 ON · 자리배분 없음": "r10≤0 ∧ lag≤30 · TP2%/stop6%/hold90 · skip rescue (age·catalyst excluded) · notional300% · orders ON · no seat alloc",
  "이 k 는 이 레인 혼자의 상한일 뿐 합이 아니다.": "This k is this lane's own cap only, not a sum.",
  "이 목록의 종목만.": "Only symbols on this list.",
  "이 알림에 진입했다면 얼마였나": "What if we had entered this alert?",
  "이 이익부터 고점 추적을 시작한다.": "Start peak tracking from this profit.",
  "이 이익이면 청산.": "Close at this profit.",
  "이 축은 \"움직였나\"만 답한다 — 규칙 값은 지금 라이브 v2": "This axis only answers \"did it move\" — rule values are live v2 now",
  "이 축은 \"움직였나\"만 답한다. 얼마나 옮길지는 아래 홀드 표(총합)가 정한다.": "This axis only answers \"did it move?\". How far to move is set by the hold table (total) below.",
  "이 판정은": "This verdict is",
  "이미 반영과 동일": "Same as already applied",
  "이미 반영됐겠지": "Probably already reflected",
  "이미 실행 중": "Already running",
  "일~목 18:15 ET 리밸런스": "Sun–Thu 18:15 ET rebalance",
  "자동": "Auto",
  "자동 실행 중": "Auto running",
  "자동 적용하지 않는다. 표 「적용」= 패스키로 DB 반영(다음 사이클에 라이브).": "Does not auto-apply. Table 「Apply」= write DB via passkey (live next cycle).",
  "자동·수동 재판정 모두 이 값을 쓴다": "Auto·manual retune both use this value",
  "자동적용 ON — 통과하면 라이브가 이 값을 집어간다.": "Auto-apply ON — on pass, live picks up this value.",
  "자리": "Slot",
  "자리 없으면 같은종목 열린 책에 조각을 붙인다(숏 평단이 더 좋은 쪽).": "If no slot, add a leg to the open same-symbol book (better short avg).",
  "자리가 없거나 다른 책과 겹칠 때의 처리.": "What to do when no slot or overlap with another book.",
  "자리없으면 같은종목 연책조각": "If no slot, same-symbol book add",
  "자리없으면 같은종목 연책조각(평단 나쁜 쪽)": "If no slot, same-symbol book add (worse avg side)",
  "자리없으면 같은종목 연책조각(평단 좋은 쪽)": "If no slot, same-symbol book add (better avg side)",
  "자본 100%": "Capital 100%",
  "자본 전부 (증거금 100%)": "Full capital (margin 100%)",
  "자본/슬롯이 막은 것": "Blocked by capital/slots",
  "잔고경로(고점확인OFF)": "Equity path (peak confirm OFF)",
  "잔고밀림": "Eq drawdown",
  "잔고밀림%": "Eq drawdown%",
  "잔고밀림%=구간 시작 대비·실명목(원장과 동일). 숫자 차=CF 경로(net%/홀드) vs 실체결.": "Eq drawdown%=vs window start·real notional (same as ledger). Gap=CF path (net%/hold) vs real fills.",
  "잔고최악": "Equity worst",
  "장부에 없는 포지션(고아)": "Exchange orphan position",
  "재생 프레임": "Replay frame",
  "재숏": "Re-short",
  "재숏 보류": "Re-short held",
  "재숏금지": "No re-short",
  "재알림": "Re-alert",
  "재알림 중복": "Re-alert dedup",
  "재진입": "Re-entry",
  "재진입 역전": "Re-entry reversal",
  "재진입 유지": "Re-entry OK",
  "재진입 유지 — leg2+ 승률 ≥ leg1": "Re-entry OK — leg2+ win rate ≥ leg1",
  "재판정 대상 아님 — 고정 규칙 (유저 2026-09-04)": "Not a retune target — fixed rule (user 2026-09-04)",
  "재판정 대상 아님 — 고정 규칙 (유저 2026-09-05)": "Not a retune target — fixed rule (user 2026-09-05)",
  "재판정 스케줄": "Retune schedule",
  "재판정 스케줄 (한국시간)": "Retune schedule (KST)",
  "재해모드": "Disaster mode",
  "재해모드 ON": "Disaster mode ON",
  "재해헤지 ON": "Disaster hedge ON",
  "재확인창": "Re-check window",
  "재확인창 OFF": "Re-check window OFF",
  "재확인창 ON": "Re-check window ON",
  "저녁은 꺾임 · 산은 산진입": "Evening=drop · mountain=mountain entry",
  "저장": "Save",
  "저장 실패": "Save failed",
  "저장 중…": "Saving…",
  "저점": "Trough",
  "저점 대비 +10%로 산이 시작된 뒤 3시간이 지나야 한다. 고점 대비 −20%면 그 산은 끝이다.": "Mountain starts at trough+10%, then needs ≥3h. Ends if −20% vs peak.",
  "적용": "Apply",
  "적용됐다": "Applied",
  "전 레인 정지": "Halt all lanes",
  "전제": "Premise",
  "정본은 db야": "SoT is the DB",
  "정산된 원장이 없다.": "No settled ledger rows.",
  "정상": "OK",
  "정지": "Halt",
  "정체": "Stale",
  "제외": "Exclude",
  "조각": "Legs",
  "조각 없음 · cum≥100→v2": "No legs · cum≥100→v2",
  "조각 최대": "Max legs",
  "조각최대": "max legs",
  "조건 대기": "Waiting on condition",
  "조기": "Early",
  "조기-OI": "Early-OI",
  "주문": "Orders",
  "주문 API 실패": "Order API fail",
  "주문 OFF": "Orders OFF",
  "주문 OFF(반사실)": "Orders OFF (counterfactual)",
  "주문 ON": "Orders ON",
  "주문 스위치 OFF (기록만)": "Order switch OFF (log only)",
  "주문 스위치.": "Order switch.",
  "주문 실패": "Order failed",
  "주문 정지 (HALTED)": "Orders halted (HALTED)",
  "중앙": "Median",
  "증거금": "Margin",
  "증거금 배분 (자본 대비)": "Margin alloc (% of capital)",
  "증거금 부족": "Insufficient margin",
  "증거금 예산선 (자본의 %, 배분 100%일 때 쓸 상한)": "Margin budget line (% of capital when alloc=100%)",
  "증거금부족": "Insufficient margin",
  "지금 라이브": "Current live",
  "지금 뭔가 조치가 필요하다": "Action needed now",
  "지금 설정이 앞뒤가 맞고 배선이 살아 있나": "Is current config consistent and wired live?",
  "지금 적용 중인 필터 · 반사실 (배포된 설정에서 읽음)": "Filters in force · counterfactual (read from deployed settings)",
  "지금 진입이 막혀 있는 종목.": "Symbols currently blocked from entry.",
  "지금 체제가 배포된 창과 맞는가": "Does the regime match the deployed window?",
  "지연-가격": "Lag-price",
  "지연20%": "Delayed 20%",
  "지표": "Metric",
  "직전 5초 거래대금이 그 앞 15초보다 식었는지. OI 조건과 같이 맞을 때만 제외.": "Whether last 5s volume cooled vs prior 15s. Exclude only with OI condition too.",
  "직전 조각보다 이 % 더 오르면 다음 조각.": "Next leg when this % above prior leg.",
  "직전변동": "Prior range",
  "진입": "Entry",
  "진입 n": "Entry n",
  "진입 대기": "Entry pending",
  "진입 전 고점확인을 쓰는지.": "Whether peak confirm is used before entry.",
  "진입 전에 요구하는 되돌림.": "Pullback required before entry.",
  "진입 직전 60초 미결제약정. 겹롱은 −2% 이하이고 막판 체결이 식으면 뺀다. 녹화가 없으면 남긴다.": "OI in 60s before entry. Gyeop long drops if ≤−2% and late flow cooled. Keep if no recording.",
  "진입 직전 재확인창": "Re-check window before entry",
  "진입 직전 확인. 편승은 확인에 필요한 상승. 겹롱은 저점 대비 상승.": "Confirm before entry. Pump ride needs confirm rise. Gyeop long needs rise vs trough.",
  "진입 틱이 직전 15초 마크 대비 이만큼 이상 올랐을 때만. 겹롱은 ≥8%.": "Only if entry tick is up this much vs prior 15s mark. Gyeop long ≥8%.",
  "진입(예정)": "Entry (planned)",
  "진입가 대비 +3% 역행(1~45초). 빠른 폭주형": "+3% adverse vs entry (1~45s). Fast blow-off type",
  "진입가 이상": "At/above entry",
  "진입률": "Entry rate",
  "진입모드": "Entry mode",
  "진입실패": "Entry fail",
  "진입을 허용하는 시각.": "Hours when entry is allowed.",
  "진입정지": "Entry halt",
  "진입정지로 방어 — 촉매 OFF면 강제청산": "Defend via entry halt — forced liquidation if catalyst OFF",
  "진입중앙": "Entry median",
  "집계가 깨졌다": "Aggregation broken",
  "차트": "Chart",
  "참고 ·": "Note ·",
  "창": "Window",
  "창 시작 100 + 보유 중 마크 틱 MTM (params.worst_eq_mtm). 정산만 보면 0으로 가려진다.": "Window start 100 + open mark-tick MTM (params.worst_eq_mtm). Settles alone look like 0.",
  "창 전체 집계 (일별 합이 아님 — 서버 창 요약)": "Full-window aggregate (not daily sum — server window summary)",
  "창 전체 집계 (일별 합이 아님)": "Full-window aggregate (not daily sum)",
  "채점 구간": "Score window",
  "채점된 진입이 없다. (일일 잡 `mercury-bh-pb-daily` 미실행 또는 마크 공백)": "No scored entries. (daily job `mercury-bh-pb-daily` not run or mark gap)",
  "채점된 진입이 없다. (일일 잡이 아직 안 돌았거나 틱 공백)": "No scored entries. (daily job not run yet or tick gap)",
  "채택": "Adopt",
  "채택후보": "Adopt candidates",
  "책": "Book",
  "첫 칸(최선)과 셋째 칸(보유)은 **다른 축**이다 —": "First cell (best) and third cell (open) are **different axes** —",
  "첫단": "First rung",
  "청": "Liq",
  "청산": "Close",
  "청산 레인 반사실": "Liq lane counterfactual",
  "청산 레인 증거금 예약": "Liq-lane margin reserved",
  "청산 캐스케이드 재판정": "Liq cascade retune",
  "청캐": "Liq cascade",
  "청캐 mid 빠른사다리 · 숏 제외": "Liq mid fast ladder · skip short",
  "청캐 v1": "Liq cascade v1",
  "청캐 v1(되돌림) — 일일 채점": "Liq cascade v1 (pullback) — daily score",
  "청캐 v2": "Liq cascade v2",
  "청캐 v2 보유중 업숏·빗숏 신규 차단": "While liq cascade v2 open, block new Upbit short·Bithumb short",
  "청캐 v2 사다리": "Liq cascade v2 ladder",
  "청캐 v2(사다리)": "Liq cascade v2 (ladder)",
  "청캐 v2(사다리). v1 은 OFF (2026-09-09).": "Liq cascade v2 (ladder). v1 is OFF (2026-09-09).",
  "청캐 v2는 조각(n_legs/max_legs), v3는 단건(n/1). 다른 레인은 –.": "Liq cascade v2 uses legs (n_legs/max_legs); v3 is single (n/1). Other lanes –.",
  "청캐 v3": "Liq cascade v3",
  "청캐 v3 (얕은산) — 일일 채점": "Liq cascade v3 (shallow mountain) — daily score",
  "청캐 낙하칼 — 일일 채점": "Liq cascade drop knife — daily score",
  "청캐 누적 75+ · 같은종목 양보": "Liq cum 75+ · yield same symbol",
  "청캐 레인과 동일": "Same as liq cascade lane",
  "청캐 사다리 (liqv2) — 일일 채점": "Liq cascade ladder (liqv2) — daily score",
  "청캐 슬롯 초과": "Liq slots full",
  "청캐 우선 · 같은종목 양보": "Liq priority · yield same symbol",
  "청캐 재판정": "Liq cascade retune",
  "청캐 진입 시 타레인 강제청산": "Force-close other lanes on liq cascade entry",
  "청캐제외": "Exclude liq cascade",
  "체결 시각의 직전 10분. 넘으면 뺀다.": "10m before fill time. Drop if over.",
  "체결10분": "Fill 10m",
  "체인종료": "Chain end",
  "촉매": "Catalyst",
  "촉매 종목을 진입에서 빼는지. 청캐는 캘린더 창 진입정지.": "Whether catalyst symbols are excluded from entry. Liq cascade uses calendar entry halt.",
  "촉매OFF": "Catalyst OFF",
  "총합": "Total",
  "총합1위": "Total #1",
  "총합순": "By total",
  "최근": "Recent",
  "최대낙폭": "Max drawdown",
  "최소노션 미달": "Below min notional",
  "최악": "Worst",
  "최악비중": "Worst share",
  "최적 패키지": "Best package",
  "추가진입 보류": "Add-on entry held",
  "축소진입": "Sized-down entry",
  "축은 되돌림% × 감시분 × peak% × stall분 × hold_after 다섯. 판정축은 슬롯 k 를 채운 창 합계이고, **같은 분 다른 심볼 대조군 대비**로 잰다.": "Axes: pullback% × watch-m × peak% × stall-m × hold_after. Verdict axis is window sum filling slot k, measured **vs same-minute other-symbol controls**.",
  "축은 확인 × 홀드 × k × dd × hs. evolve 는 끈 상태 고정. 「배포」칸은": "Axes: confirm × hold × k × dd × hs. evolve fixed off. 「Deployed」 cell is",
  "취소": "Cancel",
  "칼 OFF": "Knife OFF",
  "캐스케이드": "Cascade",
  "캡": "Cap",
  "캡잔여(k=0)": "Cap remainder (k=0)",
  "크기": "Size",
  "킬 floor": "Kill floor",
  "킬 여유": "Kill headroom",
  "킬스위치": "Kill switch",
  "타이머 깨움": "Timer wake",
  "타이머 재판정이 돌고 있다 — 끝날 때까지 수동 실행 불가": "Timer retune running — no manual run until done",
  "타이밍 · 진입 뒤 최선 ↓+": "Timing · best after entry ↓+",
  "타이밍 늦음": "Timing late",
  "타이밍 드리프트": "Timing drift",
  "타이밍 밀림": "Timing slip",
  "타이밍 유지": "Timing OK",
  "타이밍 유지 — 진입 중앙이 감시창 안에 있다": "Timing OK — entry median inside watch window",
  "타이밍 유지 — 확인 lag가 감시창 안에 있다": "Timing OK — confirm lag inside watch window",
  "탈출": "Escape",
  "탈출규칙 없이 홀드했으면?": "If held without exit rules?",
  "통합 실제 원장 — live_ledger · 청캐 전체 · 날짜=발동 KST": "Unified real ledger — live_ledger · all liq cascade · date=trigger KST",
  "통합 일일채점 — live_plain(고점OFF) + v3": "Unified daily score — live_plain(peak OFF) + v3",
  "트레일": "Trail",
  "트리거": "Trigger",
  "트리거 직후 낙폭이 크면 되돌림 대기를 건너뛰고 즉시 숏 →": "If drop right after trigger is large, skip pullback wait and short immediately →",
  "트리거가에 첫 조각": "First leg at trigger price",
  "트리거가에 첫 조각. ": "First leg at trigger price. ",
  "틱": "Ticks",
  "파도": "Wave",
  "파도(breadth)에 따라 전환": "Switch by wave (breadth)",
  "파도일 때만 쓰는 진입 규칙. 적용 kind=": "Entry rule only on wave days. apply kind=",
  "판정 ok": "Verdict ok",
  "판정 보류": "Verdict pending",
  "판정 아님": "Not judged",
  "판정 창 전체 수익(%p)": "Verdict-window total return (%p)",
  "판정 창 전체 수익(%p) = 슬롯을 채운 합": "Verdict-window total return (%p) = sum filling slots",
  "판정 창(시간)": "Verdict window (time)",
  "판정선 n≥10 · 건당≥+5 · 승≥65 · MDD&gt;−25. 건강도 진입중앙≤60분 · 스탑≤25%.": "Line n≥10 · per trade≥+5 · win≥65 · MDD&gt;−25. Health entry median≤60m · stop≤25%.",
  "패스키": "Passkey",
  "패스키 기기 등록": "Passkey device enroll",
  "패스키로 DB 적용 (라이브 즉시)": "Apply to DB via passkey (live immediate)",
  "패스키로 저장": "Save via passkey",
  "패키지 OFF": "Package OFF",
  "패키지 ON": "Package ON",
  "패키지 ON 때만 적용 (`bh_ladder_package`). 후보 75/100/100 — 업숏 175 복사 금지. 주문은 별도 OFF.": "Applies only when package ON (`bh_ladder_package`). Candidate 75/100/100 — do not copy Upbit short 175. Orders separate OFF.",
  "퍼프 미상장": "Puff not listed",
  "편승": "Pump ride",
  "편승 — 일일 채점 · 레인 건강도": "Pump ride — daily score · lane health",
  "편승 재판정": "Pump ride retune",
  "편승 재판정 ·": "Pump ride retune ·",
  "편승 주문 OFF": "Pump ride orders OFF",
  "편승 주문 ON": "Pump ride orders ON",
  "평시": "Normal",
  "포지션 금액이 자본의 몇 %. 업숏·빗숏은 구간 10%·20%·30%의 명목을 적는다. 캡을 넘기면 남은 만큼만 들어간다.": "Position as % of capital. Upbit short·Bithumb short write notional at segment 10%·20%·30%. If over cap, enter remainder only.",
  "포크+DW": "Fork+DW",
  "폭": "Width",
  "표본 대기": "Awaiting sample",
  "필요": "Need",
  "필요한": "Needed",
  "필요한 알림만": "Needed alerts only",
  "필터": "Filter",
  "필터無": "No filter",
  "하드": "Hard",
  "하드 OFF (`liq_v1_enabled: false`, 2026-09-09) — 편집 불가. 캐스케이드 초입(누적청산 &lt;100)은 아무도 안 잡는다.": "Hard OFF (`liq_v1_enabled: false`, 2026-09-09) — not editable. Cascade early (cum liq &lt;100) is uncaught.",
  "하루 1회 점검": "Check once daily",
  "한다. 적용은 표 「적용」으로 DB 에 반영.": ". Apply writes DB via table 「Apply」.",
  "합": "Sum",
  "합계": "Sum",
  "합계=건당 net% 단순합 · 사이징·고점통과는 실현%eq": "Sum=simple per-trade net% · sizing·peak pass use realized%eq",
  "합계는 taken 건당 net%를 그냥 더한 값. 캡·k·고점통과 배수는 실현%eq·잔고밀림만.": "Sum is plain add of taken per-trade net%. Cap·k·peak-pass mult only in realized%eq·eq drawdown.",
  "홀드": "Hold",
  "홀드 만기": "Hold expiry",
  "홀드 창 안 liq_trigger 수": "liq_trigger count inside hold window",
  "홀드에 지고 있으면 보유를 이 시간까지 늘린다.": "If losing at hold, extend open until this time.",
  "화면 책이 따라가는 쪽.": "Side the screen book follows.",
  "화이트": "Whitelist",
  "화이트 종목 · 문턱 20/35/50/65 · v2 진입방식": "Whitelist symbols · thresholds 20/35/50/65 · v2 entry style",
  "확인": "Confirm",
  "확인 가격에서 추가로 이만큼 더 올라야 진입.": "Must rise this much more from confirm price to enter.",
  "확인 구조 유지 — 감시창 안 BN 확인이 성립한다": "Confirm structure OK — BN confirm inside watch window works",
  "확인 붕괴": "Confirm collapse",
  "확인 상승을 재는 최저가 구간. 겹롱은 8분.": "Low window for measuring confirm rise. Gyeop long is 8m.",
  "확인 유지": "Confirm OK",
  "확인거절": "Confirm reject",
  "확인률": "Confirm rate",
  "확인이 보는 시간. 겹롱은 path 가 이 시간 안에 끝나야 한다.": "Confirm lookback. Gyeop long path must finish inside this time.",
  "확인창": "Confirm window",
  "확인창 역행 컷": "Confirm-window adverse cut",
  "회복": "Recover",
  "회복 조기청산": "Recover early close",
  "후반급등": "Late surge",
  "후보 n": "Candidates n",
  "후보-롱 슬롯 초과": "Cand-long slots full",
  "후보롱": "Cand long",
  " (상한)": " (cap)",
  "(진입정지)": "(entry halt)",
  "규칙 성적 — 셀(고점확인OFF)": "Rule score — cell (peak confirm OFF)",
  "규칙 성적 — 셀(고점확인ON)": "Rule score — cell (peak confirm ON)",
  "라이브스택 k=2 — 150/0/캡100 · 홀드 210분 · 스탑 +10%": "Live stack k=2 — 150/0/cap100 · hold 210m · stop +10%",
  "실제 원장 — live_ledger · v2 · 날짜=발동 KST (스택과 동일)": "Live ledger — live_ledger · v2 · date=trigger KST (same as stack)",
  "실제 원장 — live_ledger · 빗숏 정산 (KST)": "Live ledger — live_ledger · Bithumb short settles (KST)",
  "이 축은 u(\"움직였나\")만 답한다. 얼마나 옮길지는 아래 홀드 표(총합)가 정한다.": "This axis only answers u(\"did it move?\"). How far is set by the hold table (total) below.",
  "최신": "Latest",
  "실제 원장 — live_ledger · 업숏 정산 (KST)": "Live ledger — live_ledger · Upbit short settles (KST)",
  "실제 원장 — live_ledger · 청캐 정산 (KST)": "Live ledger — live_ledger · liq cascade settles (KST)",
  "실제 원장 — lane=liq · 날짜=발동": "Live ledger — lane=liq · date=trigger",
};

/**
 * KO → FR for /fr. Missing keys fall back to HARDCODED_KO_EN (then Korean).
 * Generated from EN map (2026-11-04); prefer Repli for 되돌림.
 */
export const HARDCODED_KO_FR: Record<string, string> = {
  " (끔 — 열린 건은 끝까지 유지)": "(OFF — transactions ouvertes conservées jusqu'à la fin)",
  " (둘 다 OFF)": " (tous deux OFF)",
  " / 다음 ": "Suivant",
  " 18칸인데 트리거는 하루 240건).": "18 créneaux mais ~240 déclencheurs/jour).",
  " [빗숏]": "[Bithumb short]",
  " · %eq 앵커는 패널 잔고행": " · ancre %eq = ligne equity du panneau",
  " · DB 없음 — yaml·기본배분 표시": "· pas de BD — affichage yaml· allocation par défaut",
  " · LSK형 캘린더 창 신규 스킵": "· ignorer les nouvelles entrées dans la fenêtre du calendrier de classe LSK",
  " · k=0(캡 잔여·실조각만 예약)": "· k=0 (reste du bouchon · jambes réelles uniquement réservées)",
  " · seg≥20 · KST 18–24 · 촉매제외 · −10%/4시간 · 15분에 더 높으면 미진입 · 산은 알림에 바로": "· seg≥20 · KST 18–24 · Catalyseur exclu · −10 %/4 h · sauter si plus haut à moins de 15 m · la montagne entre en alerte",
  " · ⚠ 한계기여 −": "· ⚠ marginal contrib −",
  " · 고점확인 OFF · 같은 k·조각·캡": " · confirm. pic OFF · mêmes k·legs·cap",
  " · 규칙이 아니라 레인 자체 · 누적청산(Σn_liq) 구간별 성적": "· voie elle-même, pas une règle · score par seau cum liq (Σn_liq)",
  " · 규칙이 아니라 레인 자체 · 화이트 트리거 · leg(cum 문턱)별": "· voie elle-même, pas une règle · déclencheurs de liste blanche · par jambe (seuil cum)",
  " · 규칙이 아니라 레인 자체 · 확인 깔때기·타이밍·사다리": "· voie elle-même, pas une règle · confirmer l'entonnoir·chronométrage·échelle",
  " · 배수 반영 합 ": "· somme appliquée par multiplicateur",
  " · 산은 진입가 +15% 위에서 OI 진입 대비 −2% 이하면 시장가 (숏커버 스퀴즈)": "· montagne : clôture du marché si entrée+15% et OI ≤ entrée−2% (short-cover squeeze)",
  " · 상세는 아래 표 진입정지·CF$ 행": "· détails dans entry-halt·CF$ lignes ci-dessous",
  " · 아직 적재 없음": "· rien encore chargé",
  " · 자리없으면 같은종목 연책조각(평단 좋은 쪽)": "· s'il n'y a pas de fente, ajouter le même symbole dans le livre (meilleur côté moyen)",
  " · 정산 없음": "· pas de règlements",
  " · 정산 없음 (라이브 OFF)": "· pas de règlement (vivre OFF)",
  " · 조각최대 ": "· max jambes",
  " · 주문=라이브스택": "· commandes= pile en direct",
  " · 체결 없음": "· pas de remplissage",
  " · 한계기여 OK": "· marginal contrib OK",
  " · 합 ": "Somme",
  " — v1 게이트 OFF (liq_v1_enabled, 2026-09-09). 이 채점은 참고용.": "— porte v1 DÉSACTIVÉE (liq_v1_enabled, 09/09/2026). Ce score n'est qu'une référence.",
  " — 끔. 업숏·빗숏이 각자 k 를 쓴다": "— OFF. Upbit short·Bithumb short utilisent chacun leur propre k",
  " — 배분>100%(선진입 우선, 저장 가능)": "— allouer>100 % (priorité de premier rang, sauvegardable)",
  " — 셀 ": "Cellule",
  " — 업숏·빗숏 종속 (레인 아님)": "— Short Upbit·Short Bithumb dépendant (pas une voie)",
  " — 자본 초과, 동시에 다 못 들어간다": "— sur le capital ; ne peut pas entrer tout à la fois",
  " — 지금 도는 설정": "— paramètres en direct actuels",
  " — 지금 도는 설정 · 셀 ": "— paramètres en direct actuels · cellule",
  " — 참고용 · 값은 위에서 고정": "— référence · valeurs fixées ci-dessus",
  " 그 시각에 청산하는 규칙으로는 그 값을 못 얻고,": "cette règle de sortie à ce moment-là ne peut pas obtenir cette valeur,",
  " 문턱 이미 진입": "seuil déjà atteint",
  " 밖": "extérieur",
  " 보유는 슬롯·비용까지 넣은 격자 총합의 답이다": "Open répond au total de la grille avec les créneaux horaires·coût inclus",
  " 시작": "début",
  " 아래 레인별 k 는 상한일 뿐 합이 아니다": "par voie k ci-dessous est un plafond seulement, pas une somme",
  " 어긋나는 것이 정상이다. 최선은 사후 최선 시점이라": "l'inadéquation est normale. Le mieux est le meilleur moment ex-post, donc",
  "% (러닝고점 대비 이만큼 꺾이면 진입 · 0 = 트리거가 즉시)": "% (entrer après cette chute du pic en cours · 0 = le déclencheur entre immédiatement)",
  "% (슬리브 등분 · 신고가가 직전조각 +이만큼일 때 다음 조각)": "% (manche fendue · jambe suivante lorsque le nouveau high est +ceci par rapport à la jambe précédente)",
  "% (진입가가 캐스케이드 고점 대비 이만큼 아래면 슬리브 ×배수 · 1× = OFF)": "% (si l'entrée est bien en dessous de la crête de la cascade, manche ×mult · 1× = OFF)",
  "% · 모양(ratio)": "% · forme (ratio)",
  "%명목 +": "Notionnel",
  "%증거금": "Marge %",
  "(별도 스위치 없음 — 위에서 청캐를 끄면 낙하칼도 같이 꺼진다).": "(pas d'interrupteur séparé — éteindre la cascade de liq ci-dessus éteint également le couteau de chute).",
  "(홀드 240분 = 자리 4시간 점유, k=3 이면 하루": "(hold 240m = siège occupé 4h ; avec k=3, un jour",
  ") 격자 권고": ") recommandation DE grille",
  "+25% · +15%&OI−2% 시장가": "+25% · +15%&OI−2% marché",
  "+3% 역행이 45초 이후 + continuation(45~120초)": "+3 % d'effets indésirables après 45 s + poursuite (45~120 s)",
  "+5% 익절": "+5 % de prise de bénéfices",
  "/rung · 캡": "/rung · cap",
  "0 = 상한 없음(캡만). >0 이면 같은종목 동시 슬리브 상한": "0 = aucune limite (casquette uniquement). >0 = nombre maximum de manches simultanées par symbole",
  "0 이면 그 필터는 **돈을 버린 것**이고,": "0 signifie que le filtre **a jeté de l'argent **,",
  "0 이면 옛 레인별 k 로 돌아간다": "0 revient à l'ancien par voie k",
  "0건": "0 métier",
  "10% 배수": "10% MULT",
  "10%→20% gap < 2h": "10 %→20 % d'écart < 2h",
  "12% 안": "dans les 12",
  "120분": "120m",
  "12시간마다": "toutes les 12h",
  "15분": "15 m",
  "15초~15분": "15s~15m",
  "1st 건당": "1er par métier",
  "1st 승률": "Taux de 1ère victoire",
  "20% 구간 제외": "Ignorer ≥20 % du segment",
  "210분": "210 m$",
  "24시간": "24h",
  "3rd+ 건당": "3e+ par métier",
  "3rd+ 승률": "3e+ taux de gain",
  "3등분": "Tertiles",
  "4시간": "4h",
  "4시간 창의 청산이 19건 이상이거나 롤 $9만 이상, 또는 알림 뒤 고점 +7.5%인데 되돌림이 그 상승분의 35% 이하.": "≥19 liqs dans une fenêtre de 4 h ou ≥ 90 000 $ , ou après un pic d'alerte de +7,5 % mais un repli ≤35 % de cette augmentation.",
  "4시간마다": "toutes les 4h",
  "50~99 건당": "50~99 par trade",
  "50~99 승률": "Taux de gain de 50~99",
  "5분": "5 m",
  "60초": "60s",
  "75/50/캡150": "75/50/cap150",
  "8분": "8m",
  "8분 저점 대비 +15% 첫 돌파 · 직전 15초 +8% 이상이면 롱": "Première pause +15% vs 8m bas · long si 15 ans précédents ≥+8%",
  "90분": "90 m",
  "<1 앞무겁게 · 1 균등 · >1 뒤무겁게": "<1 avant-lourd · 1 égal · >1 arrière-lourd",
  "=배포": "Déployé",
  "ABORT": "ABANDONNER",
  "BTC 60m 상승 과다": "Élévation de 60 m BTC trop élevée",
  "Binance perp 없음": "Pas de Binance perp",
  "DB 저장됨": "Enregistré dans la base de données",
  "Face ID / Touch ID 로 등록": "S'inscrire avec Face ID / Touch ID",
  "Globex 일 18:00–금 17:00 ET · 휴장 17–18 ET": "Dim Globex 18:00-Ven 17:00 HE · fermé 17–18 HE",
  "KR 고구간 사다리 (레인공유)": "Échelle à haut segment KR (part de voie)",
  "KR급등": "Surtension KR",
  "KST 18–24 밖": "Hors KST 18–24",
  "KST 18–24 밖이고 산 조건이 알림 시각에 맞으면 바로 숏. 되돌림을 기다리지 않는다. 빈 자리만.": "En dehors de KST 18–24, si la montagne s'adapte à l'heure d'alerte, court immédiatement. Pas d'attente de retrait. Emplacements vides uniquement.",
  "MED면 숏 flat→LONG trail40→붕괴숏. eq−50 헤지 OFF. eq스탑(−80)은 별칸.": "Sur MED : short flat→LONG trail40→collapse short. eq−50 hedge OFF. eq stop (−80) est une cellule séparée.",
  "MES·MNQ·MGC·ZN 일봉 롱 · paper": "Mes·MNQ·MGC·ZN journalier long · papier",
  "OI 밀림 · 숏 제외": "Poussée OI · skip short",
  "OIΔ≥1.5% + 매수세 증가(30~45초). 느린 유입": "OIΔ≥1,5 % + augmentation du flux d'achat (30~45s). Entrée lente",
  "[쌍숏진입] 업숏에서처리": "[Double entrée courte] gérée en Short Upbit",
  "abort 확인": "abandonner confirmer",
  "abort/no_pullback 뒤 재숏 금지": "Pas de re-short après abort/no_repli",
  "bh_dump만 · 주문 OFF": "bh_dump seul · ordres OFF",
  "book만 · 통합계와 겹치면 급락 우선": "book seul · dump prioritaire si chevauche le livre unifié",
  "cascade-fade 격자 (파도 breadth · tick mark · 관문 통과=최적 패키지)": "grille cascade-fade (largeur d'onde · marque de coche · passage de porte =meilleur forfait)",
  "cascade-fade 미발생 (감시창 만료)": "Pas de cascade-fade (montre expirée)",
  "concurrent 부족": "Concurrent trop bas",
  "drop성립": "drop OK",
  "eq스탑": "eq stop",
  "fade 관문 미달:": "porte fondue manquée :",
  "fade 마스터 OFF (대기 종료)": "Fondu maître DÉSACTIVÉ (fin de la montre)",
  "fade 주문 OFF (기록만)": "Commandes de fondu DÉSACTIVÉES (journal uniquement)",
  "fade고정": "fondu fixe",
  "halted (킬스위치)": "arrêté (interrupteur d'arrêt)",
  "k 는 사이징에 안 쓴다": "k n'est pas utilisé dans le dimensionnement",
  "k=0 · 동시 상한 없음(캡·실조각만).": "k=0 · pas de limite concurrente (cap· jambes réelles uniquement).",
  "k=0 캡만": "k=0 cap seulement",
  "k=2 · 같은 종목 210분": "k=2 · même symbole 210m",
  "kind=\\\"stop\\\" 이거나 leg 필드 도입 전 구행": "kind=\\\"stop\\\" ou lignes héritées avant le champ de jambe",
  "lag중앙": "médiane de décalage",
  "leg1 승률": "taux de gain leg1",
  "leg1≥20 건당": "leg1≥20 par trade",
  "leg2 승률": "taux de gain leg2",
  "leg2≥35 건당": "leg2≥35 par trade",
  "leg3 승률": "taux de gain leg3",
  "leg3≥50 건당": "leg3≥50 par trade",
  "leg4 승률": "taux de gain leg4",
  "leg4≥65 건당": "leg4≥65 par trade",
  "linear 레인마진 한도": "Plafond de marge de voie linéaire",
  "mark 1초 갱신": "marque 1s rafraîchissement",
  "mark 끊김": "marquer l'écart",
  "open/k. 청캐 v2·v3는 각 행.": "open/k. Liq cascade v2·v3 chaque rangée.",
  "peak도달": "pic de succès",
  "r10≤0 ∧ lag≤30 · 익절2%/스탑6%/홀드90 · 스킵 구제(나이·촉매 제외) · 명목300% · 주문 ON · 자리배분 없음": "r10≤0 ∧ lag≤30 · TP2%/stop6%/hold90 · sauvetage skip (âge·catalyseur exclus) · notionnel300% · ordres ON · pas d'alloc de siège",
  "rung1 건당": "rung1 par trade",
  "rung1 승률": "taux de gain rung1",
  "rung2+ 건당": "rung2+ par trade",
  "rung2+ 승률": "rung2+ taux de gain",
  "segment +10%p 당 +1×": "+1× par segment +10%p",
  "segment 하한 미달": "Sous le plancher du segment",
  "v1 (누적청산 &lt;100)": "v1 (cum liq &lt;100)",
  "v1 되돌림은": "le retrait de la v1 est",
  "v1 진입 정지 (누적청산 <100)": "v1 entrée interrompue (cum liq <100)",
  "v1·v2·v3 · 스택과 동일 축 · 잔고밀림%=시작대비 · 창": "v1·v2·v3 · même axe que la pile · eq drawdown%=vs start · window",
  "v2 감시": "montre v2",
  "v2 감시(고점확인)": "montre v2 (pic confirmé)",
  "v2 사다리 (누적청산 ≥100)": "v2 échelle (cum liq ≥100)",
  "v2 조각 상한 미상": "casquette de jambe v2 inconnue",
  "v2(사다리) 엔진 — v1 진입 정지": "moteur en échelle v2 — entrée v1 arrêtée",
  "v3 · v2 보유": "v3 · v2 en détention",
  "v3 문턱 미달": "v3 en dessous du seuil",
  "v3 미진입": "Aucune Entrée",
  "v3 자리 없음": "v3 sans emplacement",
  "v3 중복": "v3 doublon",
  "v3는 v2에 양보": "v3 cède à v2",
  "vs배포": "vs déployé",
  "· 업숏·빗숏 공유": "· Upbit short·Bithumb short partagé",
  "· 정산 없음": "· pas de règlements",
  "· 지금 도는 설정": "· paramètres en direct actuels",
  "· 체질 채점": "· score de constitution",
  "· 화면 설정).": "RÉGLAGE DE L'ÉCRAN",
  "× · 고점 대비": "× · vs pic",
  "×/10% · 캡": "10-CAP",
  "Δ합": "Δ somme",
  "— 동시 포지션 개수 레일.": "— rail de comptage de position simultané.",
  "※ 자동적용 OFF — 라이브는 이 행을 읽지 않는다. 통과해도 권고다.": "※ application automatique DÉSACTIVÉE — Live ne lit pas cette ligne. Le laissez-passer est uniquement à titre consultatif.",
  "※ 총합은": "Le total est",
  "→되돌림": "→repli",
  "↳ 급락": "↳ Dump",
  "↳ 되돌림": "↳ Repli",
  "↳ 익절2 별책": "↳ Cahier TP2",
  "↳급락": "↳Dump",
  "↳되돌림": "↳Repli",
  "↳익절2": "↳TP2",
  "−10% · 4시간": "−10% · 4h",
  "≤15초": "≤15s",
  "≤−2%/60초": "≤−2 %/60 s",
  "≥100 건당": "≥100 par trade",
  "≥100 승률": "Tauxde victoire ≥100",
  "≥19건·$9만 또는 고점+7.5%·≤35%": "≥19· 90 000 $ ou sommet +7,5 %·≤35 %",
  "≥3시간": "3h",
  "○ 라이브 OFF": "○ Live OFF",
  "○ 쌍숏 OFF": "○ Double court-circuit",
  "○ 촉매 진입정지 OFF — 재해헤지 · LSK 등 신규 허용": "ARRÊT de l'entrée du ○ catalyseur — couverture en cas de catastrophe · LSK, etc. nouveau autorisé",
  "○ 촉매 진입정지 — 지금 창 없음": "Arrêt de l'entrée du ○ catalyseur — pas de fenêtre maintenant",
  "● 라이브 ON": "● Live ON",
  "● 쌍숏 ON": "● Double short ON",
  "● 촉매 시드 상태 없음 — 조사 잡 확인": "● Aucun statut de graine de catalyseur — vérifiez le travail de recherche",
  "● 촉매 시드 조사 실패 — 새 촉매를 자동으로 못 찾음": "● La recherche de semences de catalyseurs a échoué — ne peut pas trouver de nouveaux catalyseurs automatiquement",
  "● 촉매 시드 조사 지연 — 마지막 성공 후 30h 초과": "Recherche de graines de ● catalyseur périmée — >30 h depuis le dernier succès",
  "⚠ 되돌림 구조 붕괴 — peak는 나오는데 되돌림 진입이 안 된다. Top1 전제가 깨진 신호": "Rupture ⚠ de la structure de rappel — des pics apparaissent mais les entrées de rappel échouent. Top1 prémisse cassée",
  "⚠ 사다리 구조 역전 — 깊은 구간이 초입보다 나쁘다. v2 의 전제가 깨진 신호": "Inversion de la structure de l'⚠échelle — seaux profonds pires qu'au début. v2 prémisse cassée",
  "⚠ 스탑이 늘었다 — taken 중 25%를 넘는다": "⚠ Les arrêts ont augmenté — plus de 25 % des prises",
  "⚠ 재진입 역전 — leg2+ 가 leg1보다 나쁘다": "Inversion de ⚠ rentrée — jambe2+ pire que jambe1",
  "⚠ 진입이 늦다 — 중앙이 60분을 넘는다": "⚠ Entrée tardive — médiane supérieure à 60 m",
  "⚠ 타이밍 밀림 — 진입 중앙이 감시창 뒤로 밀린다. 예전에 레인을 죽인 신호": "Bordereau de ⚠ chronométrage — entrée médiane passée la fenêtre de surveillance. Historiquement tué la voie",
  "⚠ 타이밍 밀림 — 확인이 늦다. 9월 드리프트 축": "Bordereau de ⚠ chronométrage — confirmer tardivement. Axe de dérive SEP",
  "⚠ 확인 구조 붕괴 — 확인률이 경보선 미만. 편승 전제가 깨진 신호": "⚠ Confirmer la rupture de la structure — confirmer le taux en dessous de la ligne d'alarme. Pump ride premise cassé",
  "✅ 등록 완료": "Inscrit",
  "✓ 스탑 비중 정상 — taken 중 25% 안": "✓ Arrêter le partage OK — dans les 25 % de la prise",
  "✓ 진입 타이밍 정상 — 중앙이 60분 안": "Calendrier ✓ d'entrée OK — médiane à moins de 60 m",
  "가격 손절. 없으면 없음.": "Arrêt du prix. Aucun si vide.",
  "가격 스탑 없음 · eq스탑(산시작 대비 잔고 −80%)은 규칙표": "Aucun arrêt de prix · eq stop (équité −80 % vs départ en montagne) n'est sur la table des règles",
  "가격% × 명목% (75/50/캡150 · k=2). 되돌림 동색 · 급락 은색 · 전승별책 금.": "Prix% × % notionnel (75/50/cap150 · k=2). Repli bronze · dump argent · WR100 or.",
  "가격% × 실제 명목% (75/50/캡100 · k=2). 되돌림 동색 · 산 은색 · 전승별책 금.": "Prix% × % notionnel réel (75/50/cap100 · k=2). Repli bronze · Montagne Silver · WR100 Gold.",
  "가격%가 −10% 이하로 끝난 뒤 4시간은 그 종목을 다시 안 넣는다.": "Une fois que le prix% se termine ≤−10 %, ignorez ce symbole pendant 4 h.",
  "가격이 그 산의 고점 12% 안.": "Prix à moins de 12 % du sommet de cette montagne.",
  "가속 없음": "Pas d'accélération",
  "가운데서 이미 조건 충족 (cold)": "Déjà atteint la mi-fenêtre (froid)",
  "가장 오래된": "Le plus agé",
  "간격": "Intervalle",
  "감시": "Regarder",
  "감시 중 요구하는 고점.": "Pic requis en regardant.",
  "감시종료": "Fin de la montre",
  "감시중": "Regarder",
  "감지 지연": "Détecter le décalage",
  "값을 바꿔야 하나": "Devrions-nous modifier la valeur ?",
  "값이다 — 라이브 손익이 아니다. 셀 사이의 비교로만 쓰고, 실적은 원장(live_ledger)을 볼 것.": "valeur — pas le PnL live. Comparer les cellules seulement ; voir grand livre (live_ledger) pour les résultats.",
  "값이다 — 라이브 손익이 아니다. 실적은 원장(live_ledger) · 위 일일채점을 볼 것.": "valeur — pas le PnL live. Voir grand livre (live_ledger) · score quotidien ci-dessus.",
  "강제청산": "Liquidation forcée",
  "같은 산에서 다시 들어가는 누적청산 간격.": "Intervalle cum-liq avant de rentrer dans la même montagne.",
  "같은 심볼 보유중": "Même symbole déjà ouvert",
  "같은 심볼 업숏 보유중": "Short Upbit même symbole ouvert",
  "같은 종목은 이 시간이 지나야 다시 진입.": "Le même symbole ne peut être saisi à nouveau qu'après cette heure.",
  "같은 코인 업비트 알림이": "Alerte Upbit de même pièce",
  "같은종목 연책": "Livre du même symbole",
  "같은종목 연책(평단 나쁜 쪽)": "Livre de même symbole (côté moyen le plus mauvais)",
  "같은종목 연책(평단 좋은 쪽)": "Livre de même symbole (meilleur côté moyen)",
  "개 · 조각 폭": "count · largeur de jambe",
  "건 /": "/",
  "건 / 다음 ": "Suivant",
  "건 →": "→",
  "건강도 — 연장 깔때기·한계기여": "Santé — prolonger l'entonnoir· contribution marginale",
  "건강도 적재가 없다.": "Aucune donnée de santé chargée.",
  "건당": "Par métier",
  "건당 net% 단순합 · 실현%eq·잔고밀림은 엔진별 캡/k 사이징 합산": "Somme simple de la somme nette par trade % · réalisé%eq·eq drawdown use per-engine cap/k sizing sum",
  "게이트 n": "Porte n",
  "격자": "Réseau",
  "격자 건수": "Nombre de grilles",
  "격자 실행": "Exécution de la grille",
  "격자 전체 셀 중 승률 순위": "Classement du taux de gain parmi toutes les cellules de la grille",
  "격자 총합 top5 (롤링": "Total grille top5 (roulant",
  "격자 총합은 재생 프레임(원장≠). path ON이면 체질 CF 채점 — 전건 스프레이와 섞지 않는다. 주문은 별도 스위치.": "Le total de la grille est le cadre de relecture (≠ledger). chemin sur le score CF de → la constitution — ne pas mélanger avec le spray tout commerce. Les commandes sont un commutateur séparé.",
  "겹": "Gy",
  "겹롱": "Long Gyeop",
  "겹롱 진입가 −5% 이하면 시장가 (소프트)": "Gyeop long : marché si ≤ entrée−5% (soft)",
  "겹침k": "chevauchement k",
  "경로청산": "Sortie du chemin",
  "경보": "Alarme",
  "경보선 n≥10 · 승률 45% / 건당 +0.5% / MDD −50 · 확인률 25% · lag 90m (사전등록 2026-09-19). 격자 총합과 섞어 읽지 말 것.": "Alerte n≥10 · gain 45% / par trade +0.5% / MDD −50 · confirm. 25% · lag 90m (prereg 2026-09-19). Ne pas mélanger avec le total grille.",
  "경보선 n≥10 · 승률 75% / 건당 +4.0% / MDD −40 (사전등록 2026-09-06).": "Alerte n≥10 · gain 75% / par trade +4.0% / MDD −40 (prereg 2026-09-06).",
  "경보선 n≥8 · 승률 50% / 건당 +1.0% / MDD −30 · v2와 같은 45일 창 · 원장은 liqv3_settle만 (라이브 OFF면 빈칸).": "Alerte n≥8 · gain 50% / par trade +1.0% / MDD −30 · même fenêtre 45j que v2 · grand livre = liqv3_settle seulement (vide si live OFF).",
  "계": "Total",
  "고점": "Pic",
  "고점 뒤 15분 초과": ">15 m après le pic",
  "고점 뒤 −되돌림까지 이 구간. 15초 미만은 age_floor, 15분 초과는 peak_age.": "Fenêtre du pic au repli. <15s = age_floor, >15m = peak_age.",
  "고점 미달 (감시창 만료)": "Pic trop bas (montre expirée)",
  "고점6 · 꺾임2 · 감시15 · 홀드15": "Pic6 · drop2 · surveillance15 · hold15",
  "고점뒤": "coqueron arrière",
  "고점을 통과한 슬리브의 크기 배수.": "Multiplicateur de taille pour les manches qui ont dépassé la crête.",
  "고점탈환": "Récupération de pointe",
  "고점통과": "CRÊTE PASSE",
  "고점확인": "Confirmation de la crête",
  "고점확인 OFF": "Confirmation de crête DÉSACTIVÉE",
  "고점확인 ON": "Confirmation DE crête ON",
  "고점확인 후 첫 조각": "Première étape après la confirmation du pic",
  "고점확인ON(arm+15%·X5%·Y30m) 후 · ": "Après la confirmation du pic ON (ARM+15%·X5% ·Y30m) ·",
  "공유": "Partagé",
  "공유 슬롯 · 청캐 우선 (DB 정본)": "Créneaux partagés · priorité cascade liq (DB SoT)",
  "관문 미달:": "Porte manquée :",
  "관문: 배포 우위 · n≥6 · 3등분 전부 양수 · 대조 excess&gt;0 · 감시 고원 · 스파이크 금지 · 이웃 과반 초과 · min_gain.": "Porte : battre déployé · n≥6 · tous les tertiles &gt;0 · contrôler l'excès&gt;0 · surveiller le plateau · pas de pics · battre la majorité des voisins · min_gain.",
  "관문: 배포 우위 · n≥8 · 3등분 전부 양수 · 격자 모서리 금지 · 이웃 과반 초과. &quot;총합1위&quot;는 관문과 무관한 참고칸이라 채택 범위 밖도 올라온다.": "Porte : battez déployé · n≥8 · tous les tertiles &gt;0 · pas de coins de grille · battez la majorité des voisins. « Total #1 » est une référence sans rapport — peut se classer en dehors de la plage d'adoption.",
  "관문을 넘은 셀 없음": "Aucune cellule n'a franchi la porte",
  "관문을 넘은 셀 없음 (정상)": "Aucune cellule n'a passé le portail (normal)",
  "관찰 중 (OI 스퀴즈 후보 · 숏 보류)": "Regarder (OI presser candidat · short held)",
  "관찰 타이밍 놓침": "Horloge de la montre manquée",
  "구간": "Segment",
  "구간 10%가 1단. 그 단의 명목, 자본 대비 %.": "Chaque segment de 10 % correspond à 1 échelon. Ce barreau est notionnel, % du capital.",
  "구간 상승": "Augmentation du segment",
  "구간 상승이 이 이상인 알림만.": "Les alertes avec segment augmentent au moins cela.",
  "구간 시작 잔고 대비 잔고밀림% (2026-10-18)": "Eq drawdown% vs equity début fenêtre (2026-10-18)",
  "구간 시작 잔고 대비 잔고밀림% (화면과 같은 축, 2026-10-18).": "Eq drawdown% vs equity début fenêtre (même axe que l'écran, 2026-10-18).",
  "구간 하락": "Chute du segment",
  "구간상승": "Augmentation du segment",
  "구간이 10%p 오를 때마다 명목에 더하는 %p. 20%는 2단, 30%는 3단.": "%p ajouté au segment notionnel de chaque +10 %p. 20 %=rung2, 30 %=rung3.",
  "구간하락": "Chute du segment",
  "구조홀드(연장) 일일 채점": "Score quotidien de maintien (extension) de la structure",
  "권고만": "Information uniquement.",
  "규칙": "Règle",
  "규칙 성적 — 셀 (얕은산 S10)": "Score de règle — cellule (montagne peu profonde S10)",
  "규칙이 발동했다": "Règle déclenchée",
  "규칙이 보고 통과시켰다": "Règle examinée et adoptée",
  "균등": "égaux",
  "그 레인이 쓸 수 있는 증거금 상한. 자본 대비 %. 넘치면 남은 만큼만 들어간다.": "Plafond de marge que cette voie peut utiliser. % du capital. Si vous avez terminé, entrez avec le reste seulement.",
  "그 시간 안 역행이 이 이상이면 진입 취소.": "Annuler l'entrée si le déménagement adverse ≥ cela dans ce délai.",
  "그 칸 최소 건손익(%p)": "PnL min par trade (%p) pour cette cellule",
  "그 칸 최소 건손익(%p) — 꼬리 크기": "PnL min par trade (%p) pour cette cellule — taille de la queue",
  "그냥 뒀으면?": "S'il est laissé seul ?",
  "급가격": "Prix rapide",
  "급등 편승 롱": "Pompe de surtension - course longue",
  "급락": "Dump",
  "급락 스캘프": "Scalp dump",
  "급락 스캘프 진입 실패": "Échec de l'entrée du cuir chevelu de",
  "급락 스캘프 진입 실패 (-3% 미터치)": "Échec de la décharge du cuir chevelu (−3 % non touché)",
  "급락 스캘프 진입 실패 (너무 빠름 lag<60s)": "Défaillance du cuir chevelu de vidange (retard trop rapide <60s)",
  "급락 스캘프 진입 실패 (캐스케이드 · 직전6h 알림≥20)": "Défaillance du cuir chevelu de vidange (cascade · ≥20 alertes/6h)",
  "급락 스캘프 진입 실패 (확인창 되돌림)": "Échec de la vidange du cuir chevelu (confirmer le retrait)",
  "기기": "Dispositif",
  "기기 이름": "Názov zariadenia",
  "기존 청캐(": "Cascade liq existante (",
  "기타": "Autre",
  "깊은꺾임 배수": "Deep-drop MULT",
  "깨짐": "Cassé",
  "꺾이면 첫 조각": "laisser tomber → la première jambe",
  "꺾임": "Tomber",
  "꺾임 2.5% · 감시 120분 · peak 2% · 홀드 90분 · 스탑 6%": "Baisse de 2,5 % · montre 120 m · pointe 2 % · maintien 90 m · arrêt 6 %",
  "낙폭 문턱": "Seuil de prélèvement",
  "낙하칼": "Collectez couteaux",
  "낙하칼 (수직낙하 즉시진입)": "Couteau de chute (entrée → immédiate de chute verticale)",
  "날짜=발동 · 잔고밀림%=시작대비·실명목(원장과 동일)": "Date=trigger · eq drawdown%=vs start·real notionnel (idem ledger)",
  "노브(적용 overlay 포함)다.": "boutons (y compris appliquer la superposition).",
  "놓친고점": "Pic manqué",
  "누적": "m3",
  "누적<50 건당": "Cum<50 par trade",
  "누적<50 승률": "Cumul<50 taux de gain",
  "누적청산": "Cum liq",
  "누적청산 ": "Cum liq",
  "누적청산 <100건 (v1 OFF)": "Cum liq <100 (v1 OFF)",
  "누적청산 ≥100 → 조각 사다리 숏": "Cum liq ≥100 → pieds échelle courte",
  "누적청산이 이 건수 이상일 때만 진입.": "Saisissez uniquement lorsque cum liq ≥ ce nombre.",
  "눌림지속": "Le tirage continue",
  "느린펌프 (lag·mom15)": "Pompe lente (lag·mom15)",
  "늦은 픽업": "Prise en charge tardive",
  "다른 레인이 보유중": "Une autre voie le retient",
  "다음 ": "suivant",
  "다음 구간 상승": "Augmentation du segment suivant",
  "다음 구간 상승 · 15분 대기 취소": "Prochaine montée du segment · annuler l'attente de 15 m",
  "단기 급등": "Surtension à court terme",
  "단기 급락": "Court terme",
  "단기급등": "Surtension à court terme",
  "단기급락": "Court terme",
  "단독 conc": "Conc solo",
  "닫기": "Séquence de clôture",
  "당일첫 · watch 과대 (scout)": "Premier jour · voir trop grand (éclaireur)",
  "대금": "Notionnel",
  "대기": "En attente",
  "대기표 만료": "La file d'attente en attente a expiré",
  "대기표 만료(60s)": "La file d'attente a expiré (60 s)",
  "대형상장": "Annonce principale",
  "더 높으면 미진입": "Ignorer si plus élevé",
  "더 뒀으면?": "Si elle est conservée plus longtemps ?",
  "돌파 추격": "Chase de cassure",
  "동시 gap": "Écart simultané",
  "동시에 들고 있는 포지션 개수 상한.": "Max postes ouverts simultanés.",
  "동일심볼 재알림 (dedup)": "Ré-alerte même symbole (dédup)",
  "되돌림": "Repli",
  "되돌림 + 급락 스캘프(bh_dump·홀드30·lag≥60s·확인60s·캐스케이드<20) · 둘 다 주문": "Repli + dump scalp (bh_dump·hold30·lag≥60s· confirm60s·cascade<20) · les deux commandes",
  "되돌림 + 급락(bh_dump·홀드30) + 익절2(r10≤0∧lag≤30·TP2/S6/H90·명목300%) · 전부 주문": "Repli + dump (bh_dump·hold30) + TP2 (r10≤0∧lag≤30·TP2/S6/H90·notionnel300%) · tous en ordre",
  "되돌림 격자 총합 (관문 통과=최적 패키지)": "Total de la grille de retrait (Gate Pass=meilleur forfait)",
  "되돌림 격자 총합 top5 (창": "Grille de retrait total top5 (fenêtre",
  "되돌림 구조 유지 — peak 후 drop 진입이 성립한다": "Structure de retrait OK — laisser tomber les entrées après le travail de pointe",
  "되돌림 미발생 (감시창 만료)": "Pas de repli (montre expirée)",
  "되돌림 붕괴": "Effondrement de repli",
  "되돌림 유지": "Repli OK",
  "되돌림 진입": "Entrée de retrait",
  "되돌림 틱의 직전 10분. 넘으면 뺀다.": "10 m avant la coche de repli. Déposer si terminé.",
  "되돌림 폭 미달 (감시창 만료)": "Taille de retrait courte (montre expirée)",
  "되돌림/급락": "Repli/Dump",
  "되돌림/급락/익절2": "Repli/Dump/TP2",
  "되돌림/산": "Repli/Montagne",
  "되돌림10분": "Repli 10m",
  "되돌림: 고점 뒤 꺾임 숏": "Repli: short après repli depuis le pic",
  "되돌림: 고점 뒤 꺾임 숏 (KST 18–24)": "Repli: short après repli depuis le pic (KST 18–24)",
  "되돌림: 고점 뒤 꺾임 숏 (KST 18–24) · 산: 그 밖, 산 모양이면 알림에 바로 숏": "Repli: short après repli depuis le pic (KST 18–24) · Montagne: sinon, short à l'alerte si forme montagne",
  "되돌림: 고점 뒤 꺾임 숏 · 급락: 알림 직후 −3%/120s 스캘프": "Repli: short après repli depuis le pic · Dump: scalp −3%/120s juste après l'alerte",
  "되돌림: 고점 뒤 꺾임 숏 · 급락: 알림 직후 −3%/120s 스캘프 · 익절2: r10≤0∧lag≤30 · TP2%/S6/H90 · 명목300%": "Repli: short après repli depuis le pic · Dump: scalp −3%/120s juste après l'alerte · TP2: r10≤0∧lag≤30 · TP2%/S6/H90 · notionnel300%",
  "되돌림고정": "Repli fixe",
  "되돌림을 기다리는 시간.": "Temps d'attente pour le repli.",
  "되밀림": "Giveback",
  "뒤무겁게": "Dos lourd",
  "등록": "S'inscrire",
  "등록 중…": "inscription",
  "등록 토큰": "Jeton d'inscription",
  "등록됨": "Inscrites",
  "또는 no_pullback": "ou no_repli",
  "라이브스택": "Pile live",
  "라이브스택 — k=∞": "Pile live — k=∞",
  "라이브스택 상세": "Détail pile live",
  "라이브스택 연장경로 — rescue*/depth_gate": "Chemin prolongation pile live — rescue*/depth_gate",
  "라이브스택(고점확인OFF) — 지금 라이브 · 날짜=발동 KST": "Pile live (confirm. pic OFF) — live actuel · date=déclencheur KST",
  "라이브스택(고점확인ON) — 반사실 · 촉매 진입정지": "Pile live (confirm. pic ON) — contrefactuel · halt entrée catalyseur",
  "라이브스택=주문": "Pile live=ordres",
  "락중": "Verrouillé",
  "런업高": "Run-up High",
  "레인": "Voie",
  "레인 건강도": "Santé des voies",
  "레인 건강도 — 규칙이 아니라 청캐 레인 자체": "Santé de la voie — liq cascade Lane elle-même, pas une règle",
  "레인 건강도 — 전제·꼬리·집중 (성적과 다른 질문)": "Santé des voies — locaux·queue·concentration (question différente du score)",
  "레인 상한 합이 자본을 넘는다 — 먼저 들어간 쪽이 먹고 나머지는 축소·스킵": "Somme des limites de voie sur le capital — d'abord dans Eats ; restez rétrécissez·sautez",
  "레인 설정": "Paramètres de voie",
  "레인OFF": "Voie OFF",
  "로 고정됐다 (2026-09-06). 아래 격자·적용은 참고용 — 매일 갈아끼우지 않는다. 건강 감시는 위 일일 채점표.": "verrouillé (2026-09-06). Grille·appliquer ci-dessous sont la référence — ne pas échanger tous les jours. La surveillance de la santé est le tableau des scores quotidiens ci-dessus.",
  "로그 꼬리": "Queue de bûche",
  "롱 보류": "Longue tenue",
  "롱 전환 실험: 관찰": "Expérience longue volte-face : montre",
  "롱 주문 API 실패": "Échec de l'API de commande longue",
  "리스크": "Risque",
  "마이그레이션": "Migration",
  "마지막 수동 실행 실패": "Échec de la dernière exécution manuelle",
  "마지막 실행": "Dernière course",
  "마진캡": "Plafond de marge",
  "마크 틱 없음 (감시창 만료)": "Aucune marque (montre expirée)",
  "마크 틱 조회 실패 (감시창 만료)": "Échec de la récupération de la coche (montre expirée)",
  "만기": "Date d'expiration",
  "만료진입 거절 (감시끝 상승)": "Entrée d'expiration rejetée (augmenter à l'expiration)",
  "매수세": "Pression d'achat",
  "명목": "Notionnel",
  "명목 = 자본 × (rung1% + (rung−1)×step%). 캡이 넘치면 스킵이 아니라 남은 만큼 축소 진입.": "Notionnel = capital × (rung1% + (rung−1)×step%). Si vous dépassez le capuchon, réduisez l'entrée (ne sautez pas).",
  "명목·risk": "Notionnel·risque",
  "무변경": "Aucun changement",
  "무장": "Bras",
  "무장 뒤 고점에서 이만큼 되밀리면 청산.": "Après le bras, fermez si la restitution du pic atteint ce point.",
  "무장돼도 즉시 안 쏘고": "Même armé, ne tirez pas immédiatement",
  "문턱 미달": "Date inférieur au seuil",
  "문턱 이미 진입": "seuil déjà atteint",
  "뭔가 일어났다": "Il vient de se passer quelque chose.",
  "미fade": "Pas de fondu",
  "미결제약정이 그 산의 고점보다 5%에서 15% 아래.": "OI est de 5 % à 15 % en dessous du sommet de cette montagne.",
  "미되돌림": "Pas de repli",
  "미무장 감시 고정 · 자동이 같은 쪽이면 SKIP": "Surveillance non armée fixe · SKIP si l'auto choisit le même côté",
  "미상": "Inconnu",
  "미진입": "Pas d'entrée",
  "바로 다음 구간 알림이 더 높고 15분 안이면 그 건은 안 들어간다. 산 진입에는 안 쓴다.": "Si l'alerte segment suivante est plus haute sous 15m, skip celle-ci. Pas pour les entrées montagne.",
  "반영": "Appliqué",
  "배분 %": "Alloc %",
  "배분 합": "Somme alloc",
  "배포": "Déployé",
  "배포 셀 총합 대비 초과": "Excès vs total cellule déployée",
  "배포 패키지 총합 대비 초과": "Excès vs total package déployé",
  "백그라운드 실행 시작": "Exécution arrière-plan démarrée",
  "보유": "Ouvert",
  "보유 (롱 · abort→long)": "Ouvert (long · abort→long)",
  "본다리": "Jambe principale",
  "분봉 거래대금 미상/부족": "Volume quote 1m manquant/bas",
  "분전": "m",
  "불러오기 실패:": "Chargement échoué :",
  "불러오는 중…": "Chargement…",
  "비고": "Notes",
  "빗": "Bi",
  "빗숏": "Short Bithumb",
  "빗숏 되돌림": "Repli Bithumb",
  "빗숏 라이브스택": "Pile live short Bithumb",
  "빗숏 본계~150%(seg≥30·캡)→300%": "Short Bithumb principal~150%(seg≥30·cap)→300%",
  "빗숏 진입가": "Entrée Bithumb",
  "빗썸": "Bithumb",
  "빠른고점": "Pic rapide",
  "사다리": "Échelle",
  "사다리 구조 유지 — 누적청산 깊을수록(≥100) 초입(<50)보다 낫다": "Structure échelle OK — cum liq profond (≥100) bat le début (<50)",
  "사다리 역전": "Inversion échelle",
  "사다리 유지": "Échelle OK",
  "사이": "Entre",
  "사이즈": "Taille",
  "사이징": "Dimensionnement",
  "사이징 v2": "Dimensionnement v2",
  "사이징 반영 실현": "Réalisé avec dimensionnement",
  "사이징 반영 실현 (칸 net 합계와 다름)": "Réalisé avec dimensionnement (≠ somme net cellule)",
  "사이징=부모슬롯 따름": "Dimensionnement=suivre siège parent",
  "산 숏은 진입가 +25% STOP_MARKET. 그 전에 진입가 +15% 위에서 OI 가 진입 대비 −2% 이하면 시장가 (숏커버 스퀴즈, 2026-10-28). 아니면 210분 홀드.": "Short montagne : +25% STOP_MARKET. Avant, market si entrée+15% et OI ≤ entrée−2% (squeeze short-cover, 2026-10-28). Sinon détention 210m.",
  "산 하나당 최대 진입 횟수.": "Entrées max par montagne.",
  "산OI": "OI montagne",
  "산가격": "Prix montagne",
  "산나이": "Âge montagne",
  "산스탑": "Stop montagne",
  "산시작 대비 잔고밀림 ≤−80%면 전량 시장가 청산. 잔량 0까지 매 사이클 연타. halted.": "Si eq drawdown ≤−80% vs début montagne → aplatir market. Réessayer chaque cycle jusqu'à 0. halted.",
  "산아래": "Sous montagne",
  "산이 시작된 시각의 미결제약정 대비 +30% 이상.": "OI ≥ +30% vs début de la montagne.",
  "산진입": "Entrée montagne",
  "산횟수": "Nb montagnes",
  "상세": "Détail",
  "상승": "Hausse",
  "상위 (수천 셀 중 최고라 뽑기 편향이 있다 — 권고가 아니다)": "Top (meilleur parmi des milliers — biais de sélection ; pas une reco)",
  "상위1": "Top1",
  "상위1비중": "Part Top1",
  "상장": "Cotation",
  "설정": "Réglages",
  "설정 ·": "Réglages ·",
  "성적": "Score",
  "성적 없음": "Pas de score",
  "셀": "Cellule",
  "셀 채점 — 배포 confirm/hold/k": "Score cellule — confirm/hold/k déployés",
  "소프트": "Soft",
  "손실금지": "Sans perte",
  "손익>0 건수 / n": "Nb PnL>0 / n",
  "손익>0 건수 / n (슬롯 통과분)": "Nb PnL>0 / n (siège passé)",
  "수동": "Manuel",
  "수동 실행": "Exécution manuelle",
  "수동진입": "Entrée manuelle",
  "수동청산": "Fermeture manuelle",
  "수집만 (미거래 거래소)": "Collecte seule (exchange non tradé)",
  "스킵": "Skip",
  "스탑": "Stop",
  "스탑 OFF": "Stop OFF",
  "스탑 늘음": "Stops en hausse",
  "스탑 없음": "Pas de stop",
  "스탑 없이 30분 들었으면?": "Si détenu 30m sans stop ?",
  "스탑 이후 다시 안 들어가는 시간.": "Cooldown après stop avant ré-entrée.",
  "스탑 정상": "Stop OK",
  "스탑%": "Stop%",
  "스탑/미상": "Stop/Inconnu",
  "스탑후": "Après stop",
  "스팟": "Spot",
  "슬롯": "Siège",
  "슬롯 명목% (배분÷k)": "Notionnel% siège (alloc÷k)",
  "슬롯 초과": "Siège plein",
  "슬롯가득": "Sièges pleins",
  "슬리브 runup60 부족": "Manche runup60 trop bas",
  "슬리브 구간상승 상한": "Plafond hausse segment manche",
  "슬리브 구간상승 하한": "Plancher hausse segment manche",
  "슬리브 슬롯 초과": "Sièges manche pleins",
  "슬리브 주문 OFF (기록만)": "Ordres manche OFF (log seul)",
  "슬리브 크기 비율. 1보다 작으면 앞 슬리브가 더 크고, 합은 캡이다.": "Ratio taille manche. <1 → manches précoces plus grandes ; la somme est le cap.",
  "슬리브 하나 안의 최대 조각 수.": "Legs max dans une manche.",
  "승/정산": "Gains/réglés",
  "승률": "Taux de gain",
  "시간": "Temps",
  "식음": "Cooldown",
  "신고가": "Nouveau plus haut",
  "신고가정체": "Stall nouveau plus haut",
  "신저가": "Nouveau plus bas",
  "실제 원장 — live_ledger · exit_reason rescue:*": "Grand livre réel — live_ledger · exit_reason rescue:*",
  "실제 원장 — live_ledger · v3 · 날짜=발동 KST (스택과 동일)": "Grand livre réel — live_ledger · v3 · date=déclencheur KST (comme pile)",
  "실제 원장 — live_ledger · 편승": "Grand livre réel — live_ledger · surfer",
  "실패": "Échec",
  "실행 소요": "Durée run",
  "실행 조건": "Conditions run",
  "실행 중": "En cours",
  "실현%eq": "Réalisé%eq",
  "심볼 미해석": "Symbole non résolu",
  "심볼 필터/마크 미상": "Filtre/mark symbole inconnu",
  "심볼·KST일 빗숏 상한": "Cap short BH symbole·jour KST",
  "심볼클러스터마다 $100 리셋": "Reset $100 par cluster symbole",
  "쌍숏": "Double short",
  "쌍숏-EXIT": "Double short EXIT",
  "아직 스탑이 안 났다": "Pas encore de stop",
  "아직 적재 없음 — `analyser_upbit_rescue_daily.py --persist` 대기": "Rien chargé — attente `analyser_upbit_rescue_daily.py --persist`",
  "안 끊었으면 얼마였나": "Et si on n'avait pas coupé ?",
  "안 끊었으면?": "Sans coupe ?",
  "안 늘렸으면?": "Sans extension ?",
  "안 돌아온다": "Ne revient pas",
  "안 쓴 자본": "Capital inutilisé",
  "알림 뒤 고점": "Pic après alerte",
  "알림 심볼 차트": "Graphique symbole alerte",
  "알림 이후 틱 없음 (감시창 만료)": "Pas de ticks après alerte (surveillance expirée)",
  "알림 후 10분 안이고 직전 10분 ≥+3% 이며 고점이 +4.5~+6% 이면 뺀다 (fast_stop). 자리는 유지.": "Sous 10m de l'alerte, si 10m avant ≥+3% et pic +4.5~+6%, drop (fast_stop). Siège gardé.",
  "알림10분·r10+3·고점+4.5~+6": "Alerte10m·r10+3·pic+4.5~+6",
  "알림에 바로": "À l'alerte",
  "앞무겁게": "Avant-lourd",
  "약 10~15분": "~10~15m",
  "약 10분": "~10m",
  "약 35분": "~35m",
  "약 3분": "~3m",
  "얕은 사다리": "Échelle peu profonde",
  "얕은peak": "Pic peu profond",
  "얕은r10": "r10 peu profond",
  "얕은retr": "Retr peu profond",
  "얕은seg": "seg peu profond",
  "얕은seg·얕은peak·얕은retr·얕은r10 이 모두 맞으면 뺀다.": "Drop si seg·pic·retr·r10 peu profonds matchent tous.",
  "얕은고점": "Pic peu profond",
  "얕은고점 제외": "Exclure pic peu profond",
  "얕은고점의 고점.": "Pic du pic peu profond.",
  "얕은고점의 구간 상승.": "Hausse segment pic peu profond.",
  "얕은고점의 되돌림 비율.": "Ratio repli pic peu profond.",
  "얕은고점의 직전 10분.": "10m avant pic peu profond.",
  "업": "Up",
  "업비트": "Upbit",
  "업비트 60m runup 부족": "Runup 60m Upbit trop bas",
  "업비트 KRW/BTC/USDT 교차상장": "Cross-list Upbit KRW/BTC/USDT",
  "업비트 교차상장 N일": "Cross-list Upbit N jours",
  "업비트 선행(옛·끔)": "Prior Upbit (legacy·off)",
  "업숏": "Short Upbit",
  "업숏 k=2 인데 왜 빗숏까지 합쳐 2건에서 막히지": "Short Upbit k=2 — pourquoi bloqué à 2 avec short Bithumb aussi ?",
  "업숏 동시펌프에서 처리": "Traité sur short Upbit dual-pump",
  "업숏 되돌림 Top1 — 일일 채점": "Repli short Upbit Top1 — score quotidien",
  "업숏 레인 증거금 한도%": "Limite% marge voie short Upbit",
  "업숏 명목150%→300%": "Notionnel short Upbit 150%→300%",
  "업숏 시간창 밖": "Hors heures short Upbit",
  "업숏 알림 이후 빼는 시간.": "Délai d'exclusion après alerte short Upbit.",
  "업숏 책": "Livre short Upbit",
  "업숏·빗숏 (공유)": "Short Upbit·Short Bithumb (partagé)",
  "업숏제외": "Exclure short Upbit",
  "없음": "Aucun",
  "엔진 ON": "Moteur ON",
  "여유": "Libre",
  "역행": "Adverse",
  "역행 1.5% + OIΔ↑ + 매수세 지속(5~90초). 스퀴즈형": "Adverse 1.5% + OIΔ↑ + flux acheteur soutenu (5~90s). Type squeeze",
  "역행 stop": "Stop adverse",
  "역행 문턱": "Seuil adverse",
  "연장": "Prolonger",
  "연장 만기": "Expiration prolongation",
  "연장 일일채점 로딩…": "Chargement score quotidien prolongation…",
  "연장 일일채점:": "Score quotidien prolongation :",
  "연장 전 기본 보유 시간.": "Détention de base avant prolongation.",
  "연장 중 이만큼 회복하면 청산.": "Fermer si récupère autant pendant prolongation.",
  "열었으면 얼마였나": "Et si on avait ouvert ?",
  "오늘 업비트 알림이 온 심볼들의 24시간 1분봉 (30초 갱신)": "Barres 1m 24h pour symboles alerte Upbit du jour (rafraîch. 30s)",
  "외부청산": "Fermeture externe",
  "움직였나": "A-t-il bougé ?",
  "원장": "Grand livre",
  "원장 CF 순효과 = 회피 − 죽인엣지 (흑자였을 체결 포함)": "Grand livre CF net = évité − edge tué (inclut fills qui auraient été verts)",
  "유지": "OK",
  "이 k 는 이 레인 혼자의 상한일 뿐 합이 아니다.": "Ce k est le cap propre de cette voie seulement, pas une somme.",
  "이 목록의 종목만.": "Seuls les symboles de cette liste.",
  "이 알림에 진입했다면 얼마였나": "Et si on était entré sur cette alerte ?",
  "이 이익부터 고점 추적을 시작한다.": "Démarrer le suivi de pic à ce profit.",
  "이 이익이면 청산.": "Fermer à ce profit.",
  "이 축은 \\\"움직였나\\\"만 답한다 — 규칙 값은 지금 라이브 v2": "Cet axe répond seulement à « a-t-il bougé » — les valeurs de règle sont live v2 maintenant",
  "이 축은 \\\"움직였나\\\"만 답한다. 얼마나 옮길지는 아래 홀드 표(총합)가 정한다.": "Cet axe répond seulement à « a-t-il bougé ? ». Jusqu'où bouger est dans le tableau détention (total) ci-dessous.",
  "이 판정은": "Ce verdict est",
  "이미 반영과 동일": "Identique à déjà appliqué",
  "이미 반영됐겠지": "Probablement déjà reflété",
  "이미 실행 중": "Déjà en cours",
  "익절2": "TP2",
  "일~목 18:15 ET 리밸런스": "Rebalance dim–jeu 18:15 ET",
  "자동": "Auto",
  "자동 실행 중": "Auto en cours",
  "자동 적용하지 않는다. 표 「적용」= 패스키로 DB 반영(다음 사이클에 라이브).": "N'applique pas auto. Tableau 「Appliquer」= écrit DB via passkey (live cycle suivant).",
  "자동·수동 재판정 모두 이 값을 쓴다": "Retune auto·manuel utilisent tous deux cette valeur",
  "자동적용 ON — 통과하면 라이브가 이 값을 집어간다.": "Auto-apply ON — au pass, live prend cette valeur.",
  "자리": "Siège",
  "자리 없으면 같은종목 열린 책에 조각을 붙인다(숏 평단이 더 좋은 쪽).": "Sans siège, ajouter un leg au livre ouvert même symbole (meilleure moy. short).",
  "자리가 없거나 다른 책과 겹칠 때의 처리.": "Que faire sans siège ou chevauchement avec un autre livre.",
  "자리없으면 같은종목 연책조각": "Sans siège, ajout livre même symbole",
  "자리없으면 같은종목 연책조각(평단 나쁜 쪽)": "Sans siège, ajout livre même symbole (pire côté moy.)",
  "자리없으면 같은종목 연책조각(평단 좋은 쪽)": "Sans siège, ajout livre même symbole (meilleur côté moy.)",
  "자본 100%": "Capital 100%",
  "자본 전부 (증거금 100%)": "Capital plein (marge 100%)",
  "자본/슬롯이 막은 것": "Bloqué par capital/sièges",
  "잔고경로(고점확인OFF)": "Chemin equity (confirm. pic OFF)",
  "잔고밀림": "Écart de solde",
  "잔고밀림%": "Écart de solde %",
  "잔고밀림%=구간 시작 대비·실명목(원장과 동일). 숫자 차=CF 경로(net%/홀드) vs 실체결.": "Eq drawdown%=vs début fenêtre·notionnel réel (comme grand livre). Écart=chemin CF (net%/hold) vs fills réels.",
  "잔고최악": "Equity pire",
  "장부에 없는 포지션(고아)": "Position orpheline exchange",
  "재생 프레임": "Cadre replay",
  "재숏": "Re-short",
  "재숏 보류": "Re-short détenu",
  "재숏금지": "Pas de re-short",
  "재알림": "Ré-alerte",
  "재알림 중복": "Dédup ré-alerte",
  "재진입": "Ré-entrée",
  "재진입 역전": "Inversion ré-entrée",
  "재진입 유지": "Ré-entrée OK",
  "재진입 유지 — leg2+ 승률 ≥ leg1": "Ré-entrée OK — taux de gain leg2+ ≥ leg1",
  "재판정 대상 아님 — 고정 규칙 (유저 2026-09-04)": "Pas une cible retune — règle fixe (user 2026-09-04)",
  "재판정 대상 아님 — 고정 규칙 (유저 2026-09-05)": "Pas une cible retune — règle fixe (user 2026-09-05)",
  "재판정 스케줄": "Planning retune",
  "재판정 스케줄 (한국시간)": "Planning retune (KST)",
  "재해모드": "Mode catastrophe",
  "재해모드 ON": "Mode catastrophe ON",
  "재해헤지 ON": "Hedge catastrophe ON",
  "재확인창": "Fenêtre re-check",
  "재확인창 OFF": "Fenêtre re-check OFF",
  "재확인창 ON": "Fenêtre re-check ON",
  "저녁은 꺾임 · 산은 산진입": "Soir=drop · montagne=entrée montagne",
  "저장": "Enregistrer",
  "저장 실패": "Enregistrement échoué",
  "저장 중…": "Enregistrement…",
  "저점": "Creux",
  "저점 대비 +10%로 산이 시작된 뒤 3시간이 지나야 한다. 고점 대비 −20%면 그 산은 끝이다.": "La montagne commence à creux+10%, puis ≥3h. Fin si −20% vs pic.",
  "적용": "Appliquer",
  "적용됐다": "Appliqué",
  "전 레인 정지": "Halt toutes les voies",
  "전제": "Prémisse",
  "정본은 db야": "SoT = le DB",
  "정산된 원장이 없다.": "Aucune ligne grand livre réglée.",
  "정상": "OK",
  "정지": "Halt",
  "정체": "Périmé",
  "제외": "Exclure",
  "조각": "Manches",
  "조각 없음 · cum≥100→v2": "Pas de legs · cum≥100→v2",
  "조각 최대": "Legs max",
  "조각최대": "legs max",
  "조건 대기": "En attente de condition",
  "조기": "Précoce",
  "조기-OI": "Early-OI",
  "주문": "Ordres",
  "주문 API 실패": "Échec API ordre",
  "주문 OFF": "Ordres OFF",
  "주문 OFF(반사실)": "Ordres OFF (contrefactuel)",
  "주문 ON": "Ordres ON",
  "주문 스위치 OFF (기록만)": "Switch ordre OFF (log seul)",
  "주문 스위치.": "Switch ordre.",
  "주문 실패": "Ordre échoué",
  "주문 정지 (HALTED)": "Ordres haltés (HALTED)",
  "중앙": "Médiane",
  "증거금": "Marge",
  "증거금 배분 (자본 대비)": "Alloc marge (% du capital)",
  "증거금 부족": "Marge insuffisante",
  "증거금 예산선 (자본의 %, 배분 100%일 때 쓸 상한)": "Ligne budget marge (% capital si alloc=100%)",
  "증거금부족": "Marge insuffisante",
  "지금 라이브": "Live actuel",
  "지금 뭔가 조치가 필요하다": "Action requise maintenant",
  "지금 설정이 앞뒤가 맞고 배선이 살아 있나": "La config actuelle est-elle cohérente et branchée live ?",
  "지금 적용 중인 필터 · 반사실 (배포된 설정에서 읽음)": "Filtres en vigueur · contrefactuel (lu des réglages déployés)",
  "지금 진입이 막혀 있는 종목.": "Symboles actuellement bloqués à l'entrée.",
  "지금 체제가 배포된 창과 맞는가": "Le régime correspond-il à la fenêtre déployée ?",
  "지연-가격": "Lag-prix",
  "지연20%": "Retardé 20%",
  "지표": "Métrique",
  "직전 5초 거래대금이 그 앞 15초보다 식었는지. OI 조건과 같이 맞을 때만 제외.": "Si le volume 5s a refroidi vs 15s avant. Exclure seulement avec condition OI aussi.",
  "직전 조각보다 이 % 더 오르면 다음 조각.": "Leg suivant quand ce % au-dessus du leg précédent.",
  "직전변동": "Range préalable",
  "진입": "Entrée",
  "진입 n": "Entrée n",
  "진입 대기": "Entrée en attente",
  "진입 전 고점확인을 쓰는지.": "Si confirm. pic est utilisée avant entrée.",
  "진입 전에 요구하는 되돌림.": "Repli requis avant entrée.",
  "진입 직전 60초 미결제약정. 겹롱은 −2% 이하이고 막판 체결이 식으면 뺀다. 녹화가 없으면 남긴다.": "OI dans les 60s avant entrée. Long Gyeop drop si ≤−2% et flux tardif refroidi. Garder si pas d'enregistrement.",
  "진입 직전 재확인창": "Fenêtre re-check avant entrée",
  "진입 직전 확인. 편승은 확인에 필요한 상승. 겹롱은 저점 대비 상승.": "Confirm. avant entrée. Surfer exige hausse confirm. Long Gyeop exige hausse vs creux.",
  "진입 틱이 직전 15초 마크 대비 이만큼 이상 올랐을 때만. 겹롱은 ≥8%.": "Seulement si le tick d'entrée monte autant vs mark 15s avant. Long Gyeop ≥8%.",
  "진입(예정)": "Entrée (planifiée)",
  "진입가 대비 +3% 역행(1~45초). 빠른 폭주형": "+3% adverse vs entrée (1~45s). Type blow-off rapide",
  "진입가 이상": "À/au-dessus de l'entrée",
  "진입률": "Taux d'entrée",
  "진입모드": "Mode d'entrée",
  "진입실패": "Échec entrée",
  "진입을 허용하는 시각.": "Heures où l'entrée est autorisée.",
  "진입정지": "Halt entrée",
  "진입정지로 방어 — 촉매 OFF면 강제청산": "Défense via halt entrée — liquidation forcée si catalyseur OFF",
  "진입중앙": "Médiane entrée",
  "집계가 깨졌다": "Agrégation cassée",
  "차트": "Graphique",
  "참고 ·": "Note ·",
  "창": "Fenêtre",
  "창 시작 100 + 보유 중 마크 틱 MTM (params.worst_eq_mtm). 정산만 보면 0으로 가려진다.": "Début fenêtre 100 + MTM mark-tick ouvert (params.worst_eq_mtm). Les settles seuls semblent 0.",
  "창 전체 집계 (일별 합이 아님 — 서버 창 요약)": "Agrégat fenêtre entière (pas somme quotidienne — résumé serveur)",
  "창 전체 집계 (일별 합이 아님)": "Agrégat fenêtre entière (pas somme quotidienne)",
  "채점 구간": "Fenêtre score",
  "채점된 진입이 없다. (일일 잡 `mercury-bh-pb-daily` 미실행 또는 마크 공백)": "Pas d'entrées scorées. (job quotidien `mercury-bh-pb-daily` non lancé ou trou mark)",
  "채점된 진입이 없다. (일일 잡이 아직 안 돌았거나 틱 공백)": "Pas d'entrées scorées. (job quotidien pas encore lancé ou trou tick)",
  "채택": "Adopter",
  "채택후보": "Candidats à adopter",
  "책": "Livre",
  "첫 칸(최선)과 셋째 칸(보유)은 **다른 축**이다 —": "La 1re cellule (best) et la 3e (ouvert) sont des **axes différents** —",
  "첫단": "Premier rung",
  "청": "Liq",
  "청산": "Séquence de clôture",
  "청산 레인 반사실": "Contrefactuel voie liq",
  "청산 레인 증거금 예약": "Marge voie liq réservée",
  "청산 캐스케이드 재판정": "Retune cascade liq",
  "청캐": "Cascade liq",
  "청캐 mid 빠른사다리 · 숏 제외": "Échelle rapide liq mid · skip short",
  "청캐 v1": "Cascade liq v1",
  "청캐 v1(되돌림) — 일일 채점": "Cascade liq v1 (repli) — score quotidien",
  "청캐 v2": "Cascade liq v2",
  "청캐 v2 보유중 업숏·빗숏 신규 차단": "Tant que cascade liq v2 ouverte, bloquer nouveaux short Upbit·short Bithumb",
  "청캐 v2 사다리": "Échelle cascade liq v2",
  "청캐 v2(사다리)": "Cascade liq v2 (échelle)",
  "청캐 v2(사다리). v1 은 OFF (2026-09-09).": "Cascade liq v2 (échelle). v1 est OFF (2026-09-09).",
  "청캐 v2는 조각(n_legs/max_legs), v3는 단건(n/1). 다른 레인은 –.": "Cascade liq v2 utilise legs (n_legs/max_legs) ; v3 est simple (n/1). Autres voies –.",
  "청캐 v3": "Cascade liq v3",
  "청캐 v3 (얕은산) — 일일 채점": "Cascade liq v3 (montagne peu profonde) — score quotidien",
  "청캐 낙하칼 — 일일 채점": "Couteau de chute cascade liq — score quotidien",
  "청캐 누적 75+ · 같은종목 양보": "Cum liq 75+ · céder même symbole",
  "청캐 레인과 동일": "Identique à la voie cascade liq",
  "청캐 사다리 (liqv2) — 일일 채점": "Échelle cascade liq (liqv2) — score quotidien",
  "청캐 슬롯 초과": "Sièges liq pleins",
  "청캐 우선 · 같은종목 양보": "Priorité liq · céder même symbole",
  "청캐 재판정": "Retune cascade liq",
  "청캐 진입 시 타레인 강제청산": "Force-close autres voies à l'entrée cascade liq",
  "청캐제외": "Exclure cascade liq",
  "체결 시각의 직전 10분. 넘으면 뺀다.": "10m avant l'heure de fill. Drop si dépassé.",
  "체결10분": "Fill 10m",
  "체인종료": "Fin de chaîne",
  "촉매": "Catalyseur",
  "촉매 종목을 진입에서 빼는지. 청캐는 캘린더 창 진입정지.": "Si les symboles catalyseur sont exclus de l'entrée. Cascade liq utilise halt entrée calendrier.",
  "촉매OFF": "Catalyseur OFF",
  "총합": "Total",
  "총합1위": "Total #1",
  "총합순": "Par total",
  "최근": "Récent",
  "최대낙폭": "Max drawdown",
  "최소노션 미달": "Sous notionnel min",
  "최악": "Pire",
  "최악비중": "Part pire",
  "최적 패키지": "Meilleur package",
  "추가진입 보류": "Entrée add-on détenue",
  "축소진입": "Entrée réduite",
  "축은 되돌림% × 감시분 × peak% × stall분 × hold_after 다섯. 판정축은 슬롯 k 를 채운 창 합계이고, **같은 분 다른 심볼 대조군 대비**로 잰다.": "Axes : repli% × surveillance-m × pic% × stall-m × hold_after. L'axe verdict est la somme fenêtre remplissant le siège k, mesurée **vs contrôles autres symboles à la même minute**.",
  "축은 확인 × 홀드 × k × dd × hs. evolve 는 끈 상태 고정. 「배포」칸은": "Axes : confirm × hold × k × dd × hs. evolve fixe off. La cellule 「Déployé」 est",
  "취소": "Annuler",
  "칼 OFF": "Couteau OFF",
  "캐스케이드": "Cascade",
  "캡": "Cap",
  "캡잔여(k=0)": "Reste cap (k=0)",
  "크기": "Taille",
  "킬 floor": "Kill floor",
  "킬 여유": "Kill headroom",
  "킬스위치": "Kill switch",
  "타이머 깨움": "Réveil timer",
  "타이머 재판정이 돌고 있다 — 끝날 때까지 수동 실행 불가": "Timer retune en cours — pas d'exécution manuelle avant la fin",
  "타이밍 · 진입 뒤 최선 ↓+": "Timing · best après entrée ↓+",
  "타이밍 늦음": "Timing tardif",
  "타이밍 드리프트": "Dérive timing",
  "타이밍 밀림": "Glissement timing",
  "타이밍 유지": "Timing OK",
  "타이밍 유지 — 진입 중앙이 감시창 안에 있다": "Timing OK — médiane entrée dans fenêtre surveillance",
  "타이밍 유지 — 확인 lag가 감시창 안에 있다": "Timing OK — lag confirm. dans fenêtre surveillance",
  "탈출": "Escape",
  "탈출규칙 없이 홀드했으면?": "Si détenu sans règles de sortie ?",
  "통합 실제 원장 — live_ledger · 청캐 전체 · 날짜=발동 KST": "Grand livre réel unifié — live_ledger · toute cascade liq · date=déclencheur KST",
  "통합 일일채점 — live_plain(고점OFF) + v3": "Score quotidien unifié — live_plain(pic OFF) + v3",
  "트레일": "Trail",
  "트리거": "Déclencheur",
  "트리거 직후 낙폭이 크면 되돌림 대기를 건너뛰고 즉시 숏 →": "Si la chute juste après le déclencheur est grande, skip l'attente repli et short immédiat →",
  "트리거가에 첫 조각": "Premier leg au prix déclencheur",
  "트리거가에 첫 조각. ": "Premier leg au prix déclencheur. ",
  "틱": "Ticks",
  "파도": "Vague",
  "파도(breadth)에 따라 전환": "Switch par vague (largeur)",
  "파도일 때만 쓰는 진입 규칙. 적용 kind=": "Règle d'entrée seulement les jours vague. apply kind=",
  "판정 ok": "Verdict ok",
  "판정 보류": "Verdict en attente",
  "판정 아님": "Non jugé",
  "판정 창 전체 수익(%p)": "Rendement total fenêtre verdict (%p)",
  "판정 창 전체 수익(%p) = 슬롯을 채운 합": "Rendement total fenêtre verdict (%p) = somme remplissant les sièges",
  "판정 창(시간)": "Fenêtre verdict (temps)",
  "판정선 n≥10 · 건당≥+5 · 승≥65 · MDD&gt;−25. 건강도 진입중앙≤60분 · 스탑≤25%.": "Ligne n≥10 · par trade≥+5 · gain≥65 · MDD&gt;−25. Santé médiane entrée≤60m · stop≤25%.",
  "패스키": "Passkey",
  "패스키 기기 등록": "Enrôlement appareil passkey",
  "패스키로 DB 적용 (라이브 즉시)": "Appliquer au DB via passkey (live immédiat)",
  "패스키로 저장": "Enregistrer via passkey",
  "패키지 OFF": "Package OFF",
  "패키지 ON": "Package ON",
  "패키지 ON 때만 적용 (`bh_ladder_package`). 후보 75/100/100 — 업숏 175 복사 금지. 주문은 별도 OFF.": "S'applique seulement si package ON (`bh_ladder_package`). Candidat 75/100/100 — ne pas copier short Upbit 175. Ordres séparés OFF.",
  "퍼프 미상장": "Puff non listé",
  "편승": "Surfer",
  "편승 — 일일 채점 · 레인 건강도": "Surfer — score quotidien · santé voie",
  "편승 재판정": "Retune surfer",
  "편승 재판정 ·": "Retune surfer ·",
  "편승 주문 OFF": "Ordres surfer OFF",
  "편승 주문 ON": "Ordres surfer ON",
  "평시": "Normal",
  "포지션 금액이 자본의 몇 %. 업숏·빗숏은 구간 10%·20%·30%의 명목을 적는다. 캡을 넘기면 남은 만큼만 들어간다.": "Position en % du capital. Short Upbit·short Bithumb écrivent le notionnel aux segments 10%·20%·30%. Si au-dessus du cap, entrer le reste seulement.",
  "포크+DW": "Fork+DW",
  "폭": "Largeur",
  "표본 대기": "En attente d'échantillon",
  "필요": "Besoin",
  "필요한": "Requis",
  "필요한 알림만": "Alertes requises seulement",
  "필터": "Filtre",
  "필터無": "Pas de filtre",
  "하드": "Hard",
  "하드 OFF (`liq_v1_enabled: false`, 2026-09-09) — 편집 불가. 캐스케이드 초입(누적청산 &lt;100)은 아무도 안 잡는다.": "Hard OFF (`liq_v1_enabled: false`, 2026-09-09) — non éditable. Cascade précoce (cum liq &lt;100) non capturée.",
  "하루 1회 점검": "Vérifier une fois par jour",
  "한다. 적용은 표 「적용」으로 DB 에 반영.": ". Appliquer écrit le DB via le tableau 「Appliquer」.",
  "합": "Somme",
  "합계": "Somme",
  "합계=건당 net% 단순합 · 사이징·고점통과는 실현%eq": "Somme=net% simple par trade · dimensionnement·passage pic utilisent réalisé%eq",
  "합계는 taken 건당 net%를 그냥 더한 값. 캡·k·고점통과 배수는 실현%eq·잔고밀림만.": "La somme est l'addition simple des net% par trade pris. Cap·k·mult passage pic seulement dans réalisé%eq·eq drawdown.",
  "홀드": "Détention",
  "홀드 만기": "Expiration détention",
  "홀드 창 안 liq_trigger 수": "compte liq_trigger dans fenêtre détention",
  "홀드에 지고 있으면 보유를 이 시간까지 늘린다.": "Si perdant à la détention, prolonger l'ouvert jusqu'à ce temps.",
  "화면 책이 따라가는 쪽.": "Côté suivi par le livre écran.",
  "화이트": "Liste blanche",
  "화이트 종목 · 문턱 20/35/50/65 · v2 진입방식": "Symboles liste blanche · seuils 20/35/50/65 · style entrée v2",
  "확인": "Confirm.",
  "확인 가격에서 추가로 이만큼 더 올라야 진입.": "Doit monter autant de plus depuis le prix confirm. pour entrer.",
  "확인 구조 유지 — 감시창 안 BN 확인이 성립한다": "Structure confirm. OK — confirm. BN dans fenêtre surveillance fonctionne",
  "확인 붕괴": "Effondrement confirm.",
  "확인 상승을 재는 최저가 구간. 겹롱은 8분.": "Fenêtre basse pour mesurer la hausse confirm. Long Gyeop = 8m.",
  "확인 유지": "Confirm. OK",
  "확인거절": "Rejet confirm.",
  "확인률": "Taux confirm.",
  "확인이 보는 시간. 겹롱은 path 가 이 시간 안에 끝나야 한다.": "Lookback confirm. Le chemin long Gyeop doit finir dans ce temps.",
  "확인창": "Fenêtre confirm.",
  "확인창 역행 컷": "Coupe adverse fenêtre confirm.",
  "회복": "Récupérer",
  "회복 조기청산": "Fermeture précoce récupération",
  "후반급등": "Surge tardif",
  "후보 n": "Candidats n",
  "후보-롱 슬롯 초과": "Sièges cand-long pleins",
  "후보롱": "Cand long",
  " (상한)": " (plafond)",
  "(진입정지)": "(arrêt d'entrée)",
  "규칙 성적 — 셀(고점확인OFF)": "Score rule — cellule (confirm. pic OFF)",
  "규칙 성적 — 셀(고점확인ON)": "Score règle — cellule (confirm. pic ON)",
  "라이브스택 k=2 — 150/0/캡100 · 홀드 210분 · 스탑 +10%": "Pile live k=2 — 150/0/cap100 · hold 210m · stop +10%",
  "실제 원장 — live_ledger · v2 · 날짜=발동 KST (스택과 동일)": "Grand livre — live_ledger · v2 · date=déclenchement KST (comme la pile)",
  "실제 원장 — live_ledger · 빗숏 정산 (KST)": "Grand livre — live_ledger · règlements short Bithumb (KST)",
  "이 축은 u(\"움직였나\")만 답한다. 얼마나 옮길지는 아래 홀드 표(총합)가 정한다.": "Cet axe ne répond qu'à u(\"ça a bougé ?\"). La distance est fixée par le tableau hold (total) ci-dessous.",
  "최신": "Dernier",
  "실제 원장 — live_ledger · 업숏 정산 (KST)": "Grand livre — live_ledger · règlements short Upbit (KST)",
  "실제 원장 — live_ledger · 청캐 정산 (KST)": "Grand livre — live_ledger · règlements cascade liq (KST)",
  "실제 원장 — lane=liq · 날짜=발동": "Grand livre — lane=liq · date=déclenchement",
};

/** Default kr so unit tests without a provider keep Korean assertions. */
let hardcodedUiLocale = "kr";

/** Sync from DashboardLocaleProvider — /en → EN map · /fr → FR then EN. */
export function setHardcodedUiLocale(locale: string): void {
  hardcodedUiLocale = locale;
}

export function getHardcodedUiLocale(): string {
  return hardcodedUiLocale;
}

export function uiText(locale: string, text: string): string {
  if (!text || locale === "kr") return text;
  if (locale === "fr") {
    return HARDCODED_KO_FR[text] ?? HARDCODED_KO_EN[text] ?? text;
  }
  return HARDCODED_KO_EN[text] ?? text;
}

/** Exact lookup using the provider locale. */
export function u(text: string): string {
  return uiText(hardcodedUiLocale, text);
}

const KO_EN_KEYS_DESC = Object.keys(HARDCODED_KO_EN)
  .filter((k) => k.length >= 2)
  .sort((a, b) => b.length - a.length);

const KO_FR_KEYS_DESC = Object.keys(HARDCODED_KO_FR)
  .filter((k) => k.length >= 2)
  .sort((a, b) => b.length - a.length);

/**
 * Translate composed / backend detail strings by longest Korean fragment.
 * Skips 1-char keys (업/빗/합…) so they cannot mangle longer words.
 * /fr: FR overlay first, then EN for leftovers.
 */
export function uDeep(text: string): string {
  if (!text || hardcodedUiLocale === "kr") return text;
  const exact = uiText(hardcodedUiLocale, text);
  if (exact !== text) return exact;
  let out = text;
  if (hardcodedUiLocale === "fr") {
    for (const k of KO_FR_KEYS_DESC) {
      if (out.includes(k)) out = out.split(k).join(HARDCODED_KO_FR[k]);
    }
  }
  for (const k of KO_EN_KEYS_DESC) {
    if (out.includes(k)) out = out.split(k).join(HARDCODED_KO_EN[k]);
  }
  return out;
}
